Date.prototype.addDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

Date.prototype.removeDays = function(days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() - days);
    return dat;
};

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


/*
 * Copyright 2014 D3R Ltd
 * http://d3r.com
 *
 * D3R Standard Javascript
 *
 * You'll want at least:

    .js .d3r-show,
    .js .d3r-hide {
        cursor: pointer;
    }
    .js .d3r-hidden {
        display: none;
    }
    .js .d3r-shown {
        display: block;
    }
    .d3r-chooser {

    }
        .d3r-chooser-option,
        .d3r-multichooser-option {
            display: none;
        }
 *
 */

// hidey showey
$(document).on('click', '.d3r-show, .d3r-hide', function(e) {
    var $this = $(this),
        $target;
    if ($this.is('a')) e.preventDefault();
    if (!!$this.data('target')) {
        $target = $('#'+$this.data('target'));
    } else if (!!$this.attr('href') && "#" == $this.attr('href')[0]) {
        $target = $($this.attr('href'));
    }
    if ($target.length) {
        var hide = $this.hasClass('d3r-hide');
        $target[hide ? 'toggleClass' : 'addClass']('d3r-shown');
        $this[hide ? 'toggleClass' : 'addClass']('d3r-active');
    }
    if ($target.hasClass('d3r-shown') && $this.hasClass('d3r-autoclose')) {
        var autoclose = function(e) {
            if (!$.contains($target[0], e.target)) {
                if ($target.hasClass('d3r-shown')) {
                    e.preventDefault();
                    $target.removeClass('d3r-shown');
                    $this.removeClass('d3r-active');
                }
                $(document).off('click', autoclose);
            }
        };
        $(document).on('click', autoclose);
    }
});
// redirect from dropdowns
$(document).on('change', 'select.d3r-redirector', function(e) {
    window.location.assign($(this).val());
});
// display things based on dropdowns
$(document).on('change', 'select.d3r-chooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-chooser-option').filter('[data-chooser="'+$this.attr('id')+'"]');
    $options.removeClass('d3r-shown');

    var selectors = ['[data-chooservalue="' + $this.val() + '"]'];

    if ($this.val()) {
        selectors.push('#' + $this.val());
    }

    $options.filter(selectors.join(',')).addClass('d3r-shown');
});
$(document).on('change', 'select.d3r-multichooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-multichooser-option').filter('[data-multichooser="'+$this.attr('id')+'"]'),
        $option = $('option:selected', this);
    $options.removeClass('d3r-shown');
    $.each($option.data('values').split(' '), function(index, val) {
        var selectors = ['[data-chooservalue="' + val + '"]'];

        if (val) {
            selectors.push('#' + val);
        }

        $options.filter(selectors.join(',')).addClass('d3r-shown');
    });
});
$(document).on('change', 'input[type="radio"].d3r-chooser', function(e) {
    var $this = $(this),
        $options = $('.d3r-chooser-option').filter('[data-chooser="'+$this.attr('name')+'"]');
    $options.removeClass('d3r-shown');

    if ($this.is(':checked')) {
        var selectors = ['[data-chooservalue="' + $this.val() + '"]'];

        if ($this.val()) {
            selectors.push('#' + $this.val());
        }

        $options.filter(selectors.join(',')).addClass('d3r-shown');
    }
});

$('input[type="radio"].d3r-chooser:checked').trigger('change');

$(document).on('click', '.d3r-submit', function(e) {
    var $this = $(this);

    // If the form is invalid, don't disable the button.
    if ($this.closest('form') &&
        !$this.closest('form')[0].checkValidity()) {
        return;
    }
    // The timeout is to allow this submission to proceed. Nasty I know, sorry.
    if ($this.hasClass('d3r-disabled')) {
        e.preventDefault();
    }
    $this.addClass('d3r-disabled');
    if (!$this.is('a')) {
        setTimeout(function() {
            $this.prop('disabled', true);
        }, 0);
    }
});
$(document).on('click', '.d3r-confirm', function(e) {
    var $this = $(this),
        message = 'Are you sure?';
    if (!!$this.data('confirm')) message = $this.data('confirm');
    if (!window.confirm(message)) e.preventDefault();
});
$(document).on('click', '.d3r-scrollto', function(e) {
    var $this = $(this),
        $target;
    if (!!$this.data('target')) {
        $target = $('#'+$this.data('target'));
    } else if (!!$this.attr('href') && "#" == $this.attr('href').replace(window.location.pathname,"")[0]) {
        $target = $($this.attr('href').replace(window.location.pathname,""));
    }
    if ($target.length) {
        var hash = $target.attr("id");
        $target.removeAttr("id");
        $("html,body").animate({
            scrollTop: $target.offset().top
        }, 500, function() {
            $target.attr("id", hash);
        });
    }
});
$(document).on('click', '.d3r-popup', function(e) {
    e.preventDefault();
    var $this = $(this),
        url = $this.attr('href'),
        width = 600,
        height = 300,
        target = 'popup';
    if (!!$this.data('width')) width = $this.data('width');
    if (!!$this.data('height')) height = $this.data('height');
    if (!!$this.attr('target')) target = $this.attr('target');

    var newwindow = window.open(url, target ,'height='+height+',width='+width);
    if (window.focus) newwindow.focus();
});

/*! jQuery UI - v1.14.1 - 2025-12-15
* https://jqueryui.com
* Includes: widget.js
* Copyright OpenJS Foundation and other contributors; Licensed MIT */

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

$.ui = $.ui || {};

var version = $.ui.version = "1.14.1";


/*!
 * jQuery UI Widget 1.14.1
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/


var widgetUuid = 0;
var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {

			// Only trigger remove when necessary to save time
			events = $._data( elem, "events" );
			if ( events && events.remove ) {
				$( elem ).triggerHandler( "remove" );
			}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	if ( name === "__proto__" || name === "constructor" ) {
		return $.error( "Invalid widget name: " + name );
	}
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( Array.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr.pseudos[ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this || !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( typeof value !== "function" ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( widgetHasOwnProperty.call( input[ inputIndex ], key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( typeof instance[ options ] !== "function" ||
						options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function bindRemoveEvent() {
			var nodesToBind = [];

			options.element.each( function( _, element ) {
				var isTracked = $.map( that.classesElementLookup, function( elements ) {
					return elements;
				} )
					.some( function( elements ) {
						return elements.is( element );
					} );

				if ( !isTracked ) {
					nodesToBind.push( element );
				}
			} );

			that._on( $( nodesToBind ), {
				remove: "_untrackClassesElement"
			} );
		}

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					bindRemoveEvent();
					current = $( $.uniqueSort( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );

		this._off( $( event.target ) );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( typeof callback === "function" &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		} else if ( options === true ) {
			options = {};
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;




} );
(function($){
    $.selectreplace = function(el, options){

        var base = this;
        base.$el = $(el);
        base.el = el;

        base.init = function(){

            base.options = $.extend({},$.selectreplace.defaultOptions, options);

            var replace;

            if (base.$el.is('select')) {
                replace = base.$el;
            } else {
                replace = $('select', base.$el);
            }
            replace.wrap(function(index) {
                var $this = $(this);
                if ($this.closest(base.options.wrapper+'.'+base.options.wrapperClass).length === 0) {
                    return $('<'+base.options.wrapper+' class="'+base.options.wrapperClass+'"'+($this.attr('id') ? ' id="'+$this.attr('id')+'_selectreplace"' : '')+'/>')
                    .addClass($this.prop('disabled') ? base.options.wrapperClass+'--disabled' : '');
                }
            }).after(function(index) {
                var $this = $(this);
                if ($this.siblings(base.options.value+'.'+base.options.valueClass).length === 0) {
                    return $('<'+base.options.value+' class="'+base.options.valueClass+'"/>').text($('option[value="'+$this.val()+'"]:first', $this).text());
                }
            }).after(function(index) {
                if (base.options.svgIcon) {
                    return '<svg class="'+base.options.svgIcon+'">\
                        <use xlink:href="'+base.options.svgIconPath+'#'+base.options.svgIcon+'" />\
                    </svg>';
                }
            }).on('change', function(e) {
                var $this = $(this);
                $this.siblings(base.options.value+'.'+base.options.valueClass).text($this.find('option[value="' + $this.val() + '"]:first').text());
            }).on('focus', function() {
                $(this).closest('.'+base.options.wrapperClass).addClass(base.options.wrapperClass+'--focused');
            }).on('blur', function() {
                $(this).closest('.'+base.options.wrapperClass).removeClass(base.options.wrapperClass+'--focused');
            });
        };
        base.init();
    };

    $.selectreplace.defaultOptions = {
        wrapper     : 'div',
        wrapperClass: 'select-wrapper',
        value       : 'p',
        valueClass  : 'value',
        svgIcon     : false,
        svgIconPath : '/images/svg-symbols.svg'
    };

    $.fn.selectreplace = function(value, options){
        return this.each(function(){
            (new $.selectreplace(this, value, options));
        });
    };

})(jQuery);

// jQuery Hover Delay 1.1.0 (20130401)
// By John Terenzio | http://terenz.io/ | MIT License
(function(b){var e=b.fn.hover,d=function(a,d,e){return this.each(function(){var c;b(this).on("mouseenter mouseleave",function(b){var f=this,g="mouseenter"===b.type?a:d;c=c?window.clearTimeout(c):window.setTimeout(function(){c=void 0;g.call(f,b)},e)})})};b.fn.hover=function(){var a=Array.prototype.slice.call(arguments);return 3===a.length&&"number"===typeof a[2]?d.apply(this,a):2===a.length&&"number"===typeof a[1]?d.call(this,a[0],a[0],a[1]):e.apply(this,a)}})(window.jQuery);


/*
 * smoothscroll polyfill - v0.3.5
 * https://iamdustan.github.io/smoothscroll
 * 2016 (c) Dustan Kasten, Jeremias Menichelli - MIT License
 */

(function(w, d, undefined) {
  'use strict';

  /*
   * aliases
   * w: window global object
   * d: document
   * undefined: undefined
   */

  // polyfill
  function polyfill() {
    // return when scrollBehavior interface is supported
    if ('scrollBehavior' in d.documentElement.style) {
      return;
    }

    /*
     * globals
     */
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    /*
     * object gathering original scroll methods
     */
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    /*
     * define timing method
     */
    var now = w.performance && w.performance.now
      ? w.performance.now.bind(w.performance) : Date.now;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} x
     * @returns {Boolean}
     */
    function shouldBailOut(x) {
      if (typeof x !== 'object'
            || x === null
            || x.behavior === undefined
            || x.behavior === 'auto'
            || x.behavior === 'instant') {
        // first arg not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof x === 'object'
            && x.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError('behavior not valid');
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;
      var hasScrollableSpace;
      var hasVisibleOverflow;

      do {
        el = el.parentNode;

        // set condition variables
        isBody = el === d.body;
        hasScrollableSpace =
          el.clientHeight < el.scrollHeight ||
          el.clientWidth < el.scrollWidth;
        hasVisibleOverflow =
          w.getComputedStyle(el, null).overflow === 'visible';
      } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));

      isBody = hasScrollableSpace = hasVisibleOverflow = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    /*
     * ORIGINAL METHODS OVERRIDES
     */

    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scroll.call(
          w,
          arguments[0].left || arguments[0],
          arguments[0].top || arguments[1]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left,
        ~~arguments[0].top
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left || arguments[0],
          arguments[0].top || arguments[1]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.elScroll.call(
            this,
            arguments[0].left || arguments[0],
            arguments[0].top || arguments[1]
        );
        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
          this,
          this,
          typeof left === 'number' ? left : this.scrollLeft,
          typeof top === 'number' ? top : this.scrollTop
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      var arg0 = arguments[0];

      if (typeof arg0 === 'object') {
        this.scroll({
          left: arg0.left + this.scrollLeft,
          top: arg0.top + this.scrollTop,
          behavior: arg0.behavior
        });
      } else {
        this.scroll(
          this.scrollLeft + arg0,
          this.scrollTop + arguments[1]
        );
      }
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );
        // reveal parent in viewport
        w.scrollBy({
          left: parentRects.left,
          top: parentRects.top,
          behavior: 'smooth'
        });
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (typeof exports === 'object') {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }
})(window, document);

/*! Magnific Popup - v1.2.0 - 2024-06-08
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2024 Dmytro Semenov; */
;(function (factory) { 
if (typeof define === 'function' && define.amd) { 
 // AMD. Register as an anonymous module. 
 define(['jquery'], factory); 
 } else if (typeof exports === 'object') { 
 // Node/CommonJS 
 factory(require('jquery')); 
 } else { 
 // Browser globals 
 factory(window.jQuery || window.Zepto); 
 } 
 }(function($) { 

/*>>core*/
/**
 * 
 * Magnific Popup Core JS file
 * 
 */


/**
 * Private static constants
 */
var CLOSE_EVENT = 'Close',
	BEFORE_CLOSE_EVENT = 'BeforeClose',
	AFTER_CLOSE_EVENT = 'AfterClose',
	BEFORE_APPEND_EVENT = 'BeforeAppend',
	MARKUP_PARSE_EVENT = 'MarkupParse',
	OPEN_EVENT = 'Open',
	CHANGE_EVENT = 'Change',
	NS = 'mfp',
	EVENT_NS = '.' + NS,
	READY_CLASS = 'mfp-ready',
	REMOVING_CLASS = 'mfp-removing',
	PREVENT_CLOSE_CLASS = 'mfp-prevent-close';


/**
 * Private vars 
 */
/*jshint -W079 */
var mfp, // As we have only one instance of MagnificPopup object, we define it locally to not to use 'this'
	MagnificPopup = function(){},
	_isJQ = !!(window.jQuery),
	_prevStatus,
	_window = $(window),
	_document,
	_prevContentType,
	_wrapClasses,
	_currPopupType;


/**
 * Private functions
 */
var _mfpOn = function(name, f) {
		mfp.ev.on(NS + name + EVENT_NS, f);
	},
	_getEl = function(className, appendTo, html, raw) {
		var el = document.createElement('div');
		el.className = 'mfp-'+className;
		if(html) {
			el.innerHTML = html;
		}
		if(!raw) {
			el = $(el);
			if(appendTo) {
				el.appendTo(appendTo);
			}
		} else if(appendTo) {
			appendTo.appendChild(el);
		}
		return el;
	},
	_mfpTrigger = function(e, data) {
		mfp.ev.triggerHandler(NS + e, data);

		if(mfp.st.callbacks) {
			// converts "mfpEventName" to "eventName" callback and triggers it if it's present
			e = e.charAt(0).toLowerCase() + e.slice(1);
			if(mfp.st.callbacks[e]) {
				mfp.st.callbacks[e].apply(mfp, Array.isArray(data) ? data : [data]);
			}
		}
	},
	_getCloseBtn = function(type) {
		if(type !== _currPopupType || !mfp.currTemplate.closeBtn) {
			mfp.currTemplate.closeBtn = $( mfp.st.closeMarkup.replace('%title%', mfp.st.tClose ) );
			_currPopupType = type;
		}
		return mfp.currTemplate.closeBtn;
	},
	// Initialize Magnific Popup only when called at least once
	_checkInstance = function() {
		if(!$.magnificPopup.instance) {
			/*jshint -W020 */
			mfp = new MagnificPopup();
			mfp.init();
			$.magnificPopup.instance = mfp;
		}
	},
	// CSS transition detection, http://stackoverflow.com/questions/7264899/detect-css-transitions-using-javascript-and-without-modernizr
	supportsTransitions = function() {
		var s = document.createElement('p').style, // 's' for style. better to create an element if body yet to exist
			v = ['ms','O','Moz','Webkit']; // 'v' for vendor

		if( s['transition'] !== undefined ) {
			return true; 
		}
			
		while( v.length ) {
			if( v.pop() + 'Transition' in s ) {
				return true;
			}
		}
				
		return false;
	};



/**
 * Public functions
 */
MagnificPopup.prototype = {

	constructor: MagnificPopup,

	/**
	 * Initializes Magnific Popup plugin. 
	 * This function is triggered only once when $.fn.magnificPopup or $.magnificPopup is executed
	 */
	init: function() {
		var appVersion = navigator.appVersion;
		mfp.isLowIE = mfp.isIE8 = document.all && !document.addEventListener;
		mfp.isAndroid = (/android/gi).test(appVersion);
		mfp.isIOS = (/iphone|ipad|ipod/gi).test(appVersion);
		mfp.supportsTransition = supportsTransitions();

		// We disable fixed positioned lightbox on devices that don't handle it nicely.
		// If you know a better way of detecting this - let me know.
		mfp.probablyMobile = (mfp.isAndroid || mfp.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent) );
		_document = $(document);

		mfp.popupsCache = {};
	},

	/**
	 * Opens popup
	 * @param  data [description]
	 */
	open: function(data) {

		var i;

		if(data.isObj === false) { 
			// convert jQuery collection to array to avoid conflicts later
			mfp.items = data.items.toArray();

			mfp.index = 0;
			var items = data.items,
				item;
			for(i = 0; i < items.length; i++) {
				item = items[i];
				if(item.parsed) {
					item = item.el[0];
				}
				if(item === data.el[0]) {
					mfp.index = i;
					break;
				}
			}
		} else {
			mfp.items = Array.isArray(data.items) ? data.items : [data.items];
			mfp.index = data.index || 0;
		}

		// if popup is already opened - we just update the content
		if(mfp.isOpen) {
			mfp.updateItemHTML();
			return;
		}
		
		mfp.types = []; 
		_wrapClasses = '';
		if(data.mainEl && data.mainEl.length) {
			mfp.ev = data.mainEl.eq(0);
		} else {
			mfp.ev = _document;
		}

		if(data.key) {
			if(!mfp.popupsCache[data.key]) {
				mfp.popupsCache[data.key] = {};
			}
			mfp.currTemplate = mfp.popupsCache[data.key];
		} else {
			mfp.currTemplate = {};
		}



		mfp.st = $.extend(true, {}, $.magnificPopup.defaults, data ); 
		mfp.fixedContentPos = mfp.st.fixedContentPos === 'auto' ? !mfp.probablyMobile : mfp.st.fixedContentPos;

		if(mfp.st.modal) {
			mfp.st.closeOnContentClick = false;
			mfp.st.closeOnBgClick = false;
			mfp.st.showCloseBtn = false;
			mfp.st.enableEscapeKey = false;
		}
		

		// Building markup
		// main containers are created only once
		if(!mfp.bgOverlay) {

			// Dark overlay
			mfp.bgOverlay = _getEl('bg').on('click'+EVENT_NS, function() {
				mfp.close();
			});

			mfp.wrap = _getEl('wrap').attr('tabindex', -1).on('click'+EVENT_NS, function(e) {
				if(mfp._checkIfClose(e.target)) {
					mfp.close();
				}
			});

			mfp.container = _getEl('container', mfp.wrap);
		}

		mfp.contentContainer = _getEl('content');
		if(mfp.st.preloader) {
			mfp.preloader = _getEl('preloader', mfp.container, mfp.st.tLoading);
		}


		// Initializing modules
		var modules = $.magnificPopup.modules;
		for(i = 0; i < modules.length; i++) {
			var n = modules[i];
			n = n.charAt(0).toUpperCase() + n.slice(1);
			mfp['init'+n].call(mfp);
		}
		_mfpTrigger('BeforeOpen');


		if(mfp.st.showCloseBtn) {
			// Close button
			if(!mfp.st.closeBtnInside) {
				mfp.wrap.append( _getCloseBtn() );
			} else {
				_mfpOn(MARKUP_PARSE_EVENT, function(e, template, values, item) {
					values.close_replaceWith = _getCloseBtn(item.type);
				});
				_wrapClasses += ' mfp-close-btn-in';
			}
		}

		if(mfp.st.alignTop) {
			_wrapClasses += ' mfp-align-top';
		}

	

		if(mfp.fixedContentPos) {
			mfp.wrap.css({
				overflow: mfp.st.overflowY,
				overflowX: 'hidden',
				overflowY: mfp.st.overflowY
			});
		} else {
			mfp.wrap.css({ 
				top: _window.scrollTop(),
				position: 'absolute'
			});
		}
		if( mfp.st.fixedBgPos === false || (mfp.st.fixedBgPos === 'auto' && !mfp.fixedContentPos) ) {
			mfp.bgOverlay.css({
				height: _document.height(),
				position: 'absolute'
			});
		}

		

		if(mfp.st.enableEscapeKey) {
			// Close on ESC key
			_document.on('keyup' + EVENT_NS, function(e) {
				if(e.keyCode === 27) {
					mfp.close();
				}
			});
		}

		_window.on('resize' + EVENT_NS, function() {
			mfp.updateSize();
		});


		if(!mfp.st.closeOnContentClick) {
			_wrapClasses += ' mfp-auto-cursor';
		}
		
		if(_wrapClasses)
			mfp.wrap.addClass(_wrapClasses);


		// this triggers recalculation of layout, so we get it once to not to trigger twice
		var windowHeight = mfp.wH = _window.height();

		
		var windowStyles = {};

		if( mfp.fixedContentPos ) {
            if(mfp._hasScrollBar(windowHeight)){
                var s = mfp._getScrollbarSize();
                if(s) {
                    windowStyles.marginRight = s;
                }
            }
        }

		if(mfp.fixedContentPos) {
			if(!mfp.isIE7) {
				windowStyles.overflow = 'hidden';
			} else {
				// ie7 double-scroll bug
				$('body, html').css('overflow', 'hidden');
			}
		}

		
		
		var classesToadd = mfp.st.mainClass;
		if(mfp.isIE7) {
			classesToadd += ' mfp-ie7';
		}
		if(classesToadd) {
			mfp._addClassToMFP( classesToadd );
		}

		// add content
		mfp.updateItemHTML();

		_mfpTrigger('BuildControls');

		// remove scrollbar, add margin e.t.c
		$('html').css(windowStyles);
		
		// add everything to DOM
		mfp.bgOverlay.add(mfp.wrap).prependTo( mfp.st.prependTo || $(document.body) );

		// Save last focused element
		mfp._lastFocusedEl = document.activeElement;
		
		// Wait for next cycle to allow CSS transition
		setTimeout(function() {
			
			if(mfp.content) {
				mfp._addClassToMFP(READY_CLASS);
				mfp._setFocus();
			} else {
				// if content is not defined (not loaded e.t.c) we add class only for BG
				mfp.bgOverlay.addClass(READY_CLASS);
			}
			
			// Trap the focus in popup
			_document.on('focusin' + EVENT_NS, mfp._onFocusIn);

		}, 16);

		mfp.isOpen = true;
		mfp.updateSize(windowHeight);
		_mfpTrigger(OPEN_EVENT);

		return data;
	},

	/**
	 * Closes the popup
	 */
	close: function() {
		if(!mfp.isOpen) return;
		_mfpTrigger(BEFORE_CLOSE_EVENT);

		mfp.isOpen = false;
		// for CSS3 animation
		if(mfp.st.removalDelay && !mfp.isLowIE && mfp.supportsTransition )  {
			mfp._addClassToMFP(REMOVING_CLASS);
			setTimeout(function() {
				mfp._close();
			}, mfp.st.removalDelay);
		} else {
			mfp._close();
		}
	},

	/**
	 * Helper for close() function
	 */
	_close: function() {
		_mfpTrigger(CLOSE_EVENT);

		var classesToRemove = REMOVING_CLASS + ' ' + READY_CLASS + ' ';

		mfp.bgOverlay.detach();
		mfp.wrap.detach();
		mfp.container.empty();

		if(mfp.st.mainClass) {
			classesToRemove += mfp.st.mainClass + ' ';
		}

		mfp._removeClassFromMFP(classesToRemove);

		if(mfp.fixedContentPos) {
			var windowStyles = {marginRight: ''};
			if(mfp.isIE7) {
				$('body, html').css('overflow', '');
			} else {
				windowStyles.overflow = '';
			}
			$('html').css(windowStyles);
		}
		
		_document.off('keyup' + EVENT_NS + ' focusin' + EVENT_NS);
		mfp.ev.off(EVENT_NS);

		// clean up DOM elements that aren't removed
		mfp.wrap.attr('class', 'mfp-wrap').removeAttr('style');
		mfp.bgOverlay.attr('class', 'mfp-bg');
		mfp.container.attr('class', 'mfp-container');

		// remove close button from target element
		if(mfp.st.showCloseBtn &&
		(!mfp.st.closeBtnInside || mfp.currTemplate[mfp.currItem.type] === true)) {
			if(mfp.currTemplate.closeBtn)
				mfp.currTemplate.closeBtn.detach();
		}


		if(mfp.st.autoFocusLast && mfp._lastFocusedEl) {
			$(mfp._lastFocusedEl).trigger('focus'); // put tab focus back
		}
		mfp.currItem = null;	
		mfp.content = null;
		mfp.currTemplate = null;
		mfp.prevHeight = 0;

		_mfpTrigger(AFTER_CLOSE_EVENT);
	},
	
	updateSize: function(winHeight) {

		if(mfp.isIOS) {
			// fixes iOS nav bars https://github.com/dimsemenov/Magnific-Popup/issues/2
			var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
			var height = window.innerHeight * zoomLevel;
			mfp.wrap.css('height', height);
			mfp.wH = height;
		} else {
			mfp.wH = winHeight || _window.height();
		}
		// Fixes #84: popup incorrectly positioned with position:relative on body
		if(!mfp.fixedContentPos) {
			mfp.wrap.css('height', mfp.wH);
		}

		_mfpTrigger('Resize');

	},

	/**
	 * Set content of popup based on current index
	 */
	updateItemHTML: function() {
		var item = mfp.items[mfp.index];

		// Detach and perform modifications
		mfp.contentContainer.detach();

		if(mfp.content)
			mfp.content.detach();

		if(!item.parsed) {
			item = mfp.parseEl( mfp.index );
		}

		var type = item.type;

		_mfpTrigger('BeforeChange', [mfp.currItem ? mfp.currItem.type : '', type]);
		// BeforeChange event works like so:
		// _mfpOn('BeforeChange', function(e, prevType, newType) { });

		mfp.currItem = item;

		if(!mfp.currTemplate[type]) {
			var markup = mfp.st[type] ? mfp.st[type].markup : false;

			// allows to modify markup
			_mfpTrigger('FirstMarkupParse', markup);

			if(markup) {
				mfp.currTemplate[type] = $(markup);
			} else {
				// if there is no markup found we just define that template is parsed
				mfp.currTemplate[type] = true;
			}
		}

		if(_prevContentType && _prevContentType !== item.type) {
			mfp.container.removeClass('mfp-'+_prevContentType+'-holder');
		}

		var newContent = mfp['get' + type.charAt(0).toUpperCase() + type.slice(1)](item, mfp.currTemplate[type]);
		mfp.appendContent(newContent, type);

		item.preloaded = true;

		_mfpTrigger(CHANGE_EVENT, item);
		_prevContentType = item.type;

		// Append container back after its content changed
		mfp.container.prepend(mfp.contentContainer);

		_mfpTrigger('AfterChange');
	},


	/**
	 * Set HTML content of popup
	 */
	appendContent: function(newContent, type) {
		mfp.content = newContent;

		if(newContent) {
			if(mfp.st.showCloseBtn && mfp.st.closeBtnInside &&
				mfp.currTemplate[type] === true) {
				// if there is no markup, we just append close button element inside
				if(!mfp.content.find('.mfp-close').length) {
					mfp.content.append(_getCloseBtn());
				}
			} else {
				mfp.content = newContent;
			}
		} else {
			mfp.content = '';
		}

		_mfpTrigger(BEFORE_APPEND_EVENT);
		mfp.container.addClass('mfp-'+type+'-holder');

		mfp.contentContainer.append(mfp.content);
	},


	/**
	 * Creates Magnific Popup data object based on given data
	 * @param  {int} index Index of item to parse
	 */
	parseEl: function(index) {
		var item = mfp.items[index],
			type;

		if(item.tagName) {
			item = { el: $(item) };
		} else {
			type = item.type;
			item = { data: item, src: item.src };
		}

		if(item.el) {
			var types = mfp.types;

			// check for 'mfp-TYPE' class
			for(var i = 0; i < types.length; i++) {
				if( item.el.hasClass('mfp-'+types[i]) ) {
					type = types[i];
					break;
				}
			}

			item.src = item.el.attr('data-mfp-src');
			if(!item.src) {
				item.src = item.el.attr('href');
			}
		}

		item.type = type || mfp.st.type || 'inline';
		item.index = index;
		item.parsed = true;
		mfp.items[index] = item;
		_mfpTrigger('ElementParse', item);

		return mfp.items[index];
	},


	/**
	 * Initializes single popup or a group of popups
	 */
	addGroup: function(el, options) {
		var eHandler = function(e) {
			e.mfpEl = this;
			mfp._openClick(e, el, options);
		};

		if(!options) {
			options = {};
		}

		var eName = 'click.magnificPopup';
		options.mainEl = el;

		if(options.items) {
			options.isObj = true;
			el.off(eName).on(eName, eHandler);
		} else {
			options.isObj = false;
			if(options.delegate) {
				el.off(eName).on(eName, options.delegate , eHandler);
			} else {
				options.items = el;
				el.off(eName).on(eName, eHandler);
			}
		}
	},
	_openClick: function(e, el, options) {
		var midClick = options.midClick !== undefined ? options.midClick : $.magnificPopup.defaults.midClick;


		if(!midClick && ( e.which === 2 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey ) ) {
			return;
		}

		var disableOn = options.disableOn !== undefined ? options.disableOn : $.magnificPopup.defaults.disableOn;

		if(disableOn) {
			if(typeof disableOn === "function") {
				if( !disableOn.call(mfp) ) {
					return true;
				}
			} else { // else it's number
				if( _window.width() < disableOn ) {
					return true;
				}
			}
		}

		if(e.type) {
			e.preventDefault();

			// This will prevent popup from closing if element is inside and popup is already opened
			if(mfp.isOpen) {
				e.stopPropagation();
			}
		}

		options.el = $(e.mfpEl);
		if(options.delegate) {
			options.items = el.find(options.delegate);
		}
		mfp.open(options);
	},


	/**
	 * Updates text on preloader
	 */
	updateStatus: function(status, text) {

		if(mfp.preloader) {
			if(_prevStatus !== status) {
				mfp.container.removeClass('mfp-s-'+_prevStatus);
			}

			if(!text && status === 'loading') {
				text = mfp.st.tLoading;
			}

			var data = {
				status: status,
				text: text
			};
			// allows to modify status
			_mfpTrigger('UpdateStatus', data);

			status = data.status;
			text = data.text;

			if (mfp.st.allowHTMLInStatusIndicator) {
				mfp.preloader.html(text);
			} else {
				mfp.preloader.text(text);
			}

			mfp.preloader.find('a').on('click', function(e) {
				e.stopImmediatePropagation();
			});

			mfp.container.addClass('mfp-s-'+status);
			_prevStatus = status;
		}
	},


	/*
		"Private" helpers that aren't private at all
	 */
	// Check to close popup or not
	// "target" is an element that was clicked
	_checkIfClose: function(target) {

		if($(target).closest('.' + PREVENT_CLOSE_CLASS).length) {
			return;
		}

		var closeOnContent = mfp.st.closeOnContentClick;
		var closeOnBg = mfp.st.closeOnBgClick;

		if(closeOnContent && closeOnBg) {
			return true;
		} else {

			// We close the popup if click is on close button or on preloader. Or if there is no content.
			if(!mfp.content || $(target).closest('.mfp-close').length || (mfp.preloader && target === mfp.preloader[0]) ) {
				return true;
			}

			// if click is outside the content
			if(  (target !== mfp.content[0] && !$.contains(mfp.content[0], target))  ) {
				if(closeOnBg) {
					// last check, if the clicked element is in DOM, (in case it's removed onclick)
					if( $.contains(document, target) ) {
						return true;
					}
				}
			} else if(closeOnContent) {
				return true;
			}

		}
		return false;
	},
	_addClassToMFP: function(cName) {
		mfp.bgOverlay.addClass(cName);
		mfp.wrap.addClass(cName);
	},
	_removeClassFromMFP: function(cName) {
		this.bgOverlay.removeClass(cName);
		mfp.wrap.removeClass(cName);
	},
	_hasScrollBar: function(winHeight) {
		return (  (mfp.isIE7 ? _document.height() : document.body.scrollHeight) > (winHeight || _window.height()) );
	},
	_setFocus: function() {
		(mfp.st.focus ? mfp.content.find(mfp.st.focus).eq(0) : mfp.wrap).trigger('focus');
	},
	_onFocusIn: function(e) {
		if( e.target !== mfp.wrap[0] && !$.contains(mfp.wrap[0], e.target) ) {
			mfp._setFocus();
			return false;
		}
	},
	_parseMarkup: function(template, values, item) {
		var arr;
		if(item.data) {
			values = $.extend(item.data, values);
		}
		_mfpTrigger(MARKUP_PARSE_EVENT, [template, values, item] );

		$.each(values, function(key, value) {
			if(value === undefined || value === false) {
				return true;
			}
			arr = key.split('_');
			if(arr.length > 1) {
				var el = template.find(EVENT_NS + '-'+arr[0]);

				if(el.length > 0) {
					var attr = arr[1];
					if(attr === 'replaceWith') {
						if(el[0] !== value[0]) {
							el.replaceWith(value);
						}
					} else if(attr === 'img') {
						if(el.is('img')) {
							el.attr('src', value);
						} else {
							el.replaceWith( $('<img>').attr('src', value).attr('class', el.attr('class')) );
						}
					} else {
						el.attr(arr[1], value);
					}
				}

			} else {
				if (mfp.st.allowHTMLInTemplate) {
					template.find(EVENT_NS + '-'+key).html(value);
				} else {
					template.find(EVENT_NS + '-'+key).text(value);
				}
			}
		});
	},

	_getScrollbarSize: function() {
		// thx David
		if(mfp.scrollbarSize === undefined) {
			var scrollDiv = document.createElement("div");
			scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
			document.body.appendChild(scrollDiv);
			mfp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
		}
		return mfp.scrollbarSize;
	}

}; /* MagnificPopup core prototype end */




/**
 * Public static functions
 */
$.magnificPopup = {
	instance: null,
	proto: MagnificPopup.prototype,
	modules: [],

	open: function(options, index) {
		_checkInstance();

		if(!options) {
			options = {};
		} else {
			options = $.extend(true, {}, options);
		}

		options.isObj = true;
		options.index = index || 0;
		return this.instance.open(options);
	},

	close: function() {
		return $.magnificPopup.instance && $.magnificPopup.instance.close();
	},

	registerModule: function(name, module) {
		if(module.options) {
			$.magnificPopup.defaults[name] = module.options;
		}
		$.extend(this.proto, module.proto);
		this.modules.push(name);
	},

	defaults: {

		// Info about options is in docs:
		// http://dimsemenov.com/plugins/magnific-popup/documentation.html#options

		disableOn: 0,

		key: null,

		midClick: false,

		mainClass: '',

		preloader: true,

		focus: '', // CSS selector of input to focus after popup is opened

		closeOnContentClick: false,

		closeOnBgClick: true,

		closeBtnInside: true,

		showCloseBtn: true,

		enableEscapeKey: true,

		modal: false,

		alignTop: false,

		removalDelay: 0,

		prependTo: null,

		fixedContentPos: 'auto',

		fixedBgPos: 'auto',

		overflowY: 'auto',

		closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',

		tClose: 'Close (Esc)',

		tLoading: 'Loading...',

		autoFocusLast: true,

		allowHTMLInStatusIndicator: false,

		allowHTMLInTemplate: false

	}
};



$.fn.magnificPopup = function(options) {
	_checkInstance();

	var jqEl = $(this);

	// We call some API method of first param is a string
	if (typeof options === "string" ) {

		if(options === 'open') {
			var items,
				itemOpts = _isJQ ? jqEl.data('magnificPopup') : jqEl[0].magnificPopup,
				index = parseInt(arguments[1], 10) || 0;

			if(itemOpts.items) {
				items = itemOpts.items[index];
			} else {
				items = jqEl;
				if(itemOpts.delegate) {
					items = items.find(itemOpts.delegate);
				}
				items = items.eq( index );
			}
			mfp._openClick({mfpEl:items}, jqEl, itemOpts);
		} else {
			if(mfp.isOpen)
				mfp[options].apply(mfp, Array.prototype.slice.call(arguments, 1));
		}

	} else {
		// clone options obj
		options = $.extend(true, {}, options);

		/*
		 * As Zepto doesn't support .data() method for objects
		 * and it works only in normal browsers
		 * we assign "options" object directly to the DOM element. FTW!
		 */
		if(_isJQ) {
			jqEl.data('magnificPopup', options);
		} else {
			jqEl[0].magnificPopup = options;
		}

		mfp.addGroup(jqEl, options);

	}
	return jqEl;
};

/*>>core*/

/*>>inline*/

var INLINE_NS = 'inline',
	_hiddenClass,
	_inlinePlaceholder,
	_lastInlineElement,
	_putInlineElementsBack = function() {
		if(_lastInlineElement) {
			_inlinePlaceholder.after( _lastInlineElement.addClass(_hiddenClass) ).detach();
			_lastInlineElement = null;
		}
	};

$.magnificPopup.registerModule(INLINE_NS, {
	options: {
		hiddenClass: 'hide', // will be appended with `mfp-` prefix
		markup: '',
		tNotFound: 'Content not found'
	},
	proto: {

		initInline: function() {
			mfp.types.push(INLINE_NS);

			_mfpOn(CLOSE_EVENT+'.'+INLINE_NS, function() {
				_putInlineElementsBack();
			});
		},

		getInline: function(item, template) {

			_putInlineElementsBack();

			if(item.src) {
				var inlineSt = mfp.st.inline,
					el = $(item.src);

				if(el.length) {

					// If target element has parent - we replace it with placeholder and put it back after popup is closed
					var parent = el[0].parentNode;
					if(parent && parent.tagName) {
						if(!_inlinePlaceholder) {
							_hiddenClass = inlineSt.hiddenClass;
							_inlinePlaceholder = _getEl(_hiddenClass);
							_hiddenClass = 'mfp-'+_hiddenClass;
						}
						// replace target inline element with placeholder
						_lastInlineElement = el.after(_inlinePlaceholder).detach().removeClass(_hiddenClass);
					}

					mfp.updateStatus('ready');
				} else {
					mfp.updateStatus('error', inlineSt.tNotFound);
					el = $('<div>');
				}

				item.inlineElement = el;
				return el;
			}

			mfp.updateStatus('ready');
			mfp._parseMarkup(template, {}, item);
			return template;
		}
	}
});

/*>>inline*/

/*>>ajax*/
var AJAX_NS = 'ajax',
	_ajaxCur,
	_removeAjaxCursor = function() {
		if(_ajaxCur) {
			$(document.body).removeClass(_ajaxCur);
		}
	},
	_destroyAjaxRequest = function() {
		_removeAjaxCursor();
		if(mfp.req) {
			mfp.req.abort();
		}
	};

$.magnificPopup.registerModule(AJAX_NS, {

	options: {
		settings: null,
		cursor: 'mfp-ajax-cur',
		tError: 'The content could not be loaded.'
	},

	proto: {
		initAjax: function() {
			mfp.types.push(AJAX_NS);
			_ajaxCur = mfp.st.ajax.cursor;

			_mfpOn(CLOSE_EVENT+'.'+AJAX_NS, _destroyAjaxRequest);
			_mfpOn('BeforeChange.' + AJAX_NS, _destroyAjaxRequest);
		},
		getAjax: function(item) {

			if(_ajaxCur) {
				$(document.body).addClass(_ajaxCur);
			}

			mfp.updateStatus('loading');

			var opts = $.extend({
				url: item.src,
				success: function(data, textStatus, jqXHR) {
					var temp = {
						data:data,
						xhr:jqXHR
					};

					_mfpTrigger('ParseAjax', temp);

					mfp.appendContent( $(temp.data), AJAX_NS );

					item.finished = true;

					_removeAjaxCursor();

					mfp._setFocus();

					setTimeout(function() {
						mfp.wrap.addClass(READY_CLASS);
					}, 16);

					mfp.updateStatus('ready');

					_mfpTrigger('AjaxContentAdded');
				},
				error: function() {
					_removeAjaxCursor();
					item.finished = item.loadError = true;
					mfp.updateStatus('error', mfp.st.ajax.tError.replace('%url%', item.src));
				}
			}, mfp.st.ajax.settings);

			mfp.req = $.ajax(opts);

			return '';
		}
	}
});

/*>>ajax*/

/*>>image*/
var _imgInterval,
	_getTitle = function(item) {
		if(item.data && item.data.title !== undefined)
			return item.data.title;

		var src = mfp.st.image.titleSrc;

		if(src) {
			if(typeof src === "function") {
				return src.call(mfp, item);
			} else if(item.el) {
				return item.el.attr(src) || '';
			}
		}
		return '';
	};

$.magnificPopup.registerModule('image', {

	options: {
		markup: '<div class="mfp-figure">'+
					'<div class="mfp-close"></div>'+
					'<figure>'+
						'<div class="mfp-img"></div>'+
						'<figcaption>'+
							'<div class="mfp-bottom-bar">'+
								'<div class="mfp-title"></div>'+
								'<div class="mfp-counter"></div>'+
							'</div>'+
						'</figcaption>'+
					'</figure>'+
				'</div>',
		cursor: 'mfp-zoom-out-cur',
		titleSrc: 'title',
		verticalFit: true,
		tError: 'The image could not be loaded.'
	},

	proto: {
		initImage: function() {
			var imgSt = mfp.st.image,
				ns = '.image';

			mfp.types.push('image');

			_mfpOn(OPEN_EVENT+ns, function() {
				if(mfp.currItem.type === 'image' && imgSt.cursor) {
					$(document.body).addClass(imgSt.cursor);
				}
			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(imgSt.cursor) {
					$(document.body).removeClass(imgSt.cursor);
				}
				_window.off('resize' + EVENT_NS);
			});

			_mfpOn('Resize'+ns, mfp.resizeImage);
			if(mfp.isLowIE) {
				_mfpOn('AfterChange', mfp.resizeImage);
			}
		},
		resizeImage: function() {
			var item = mfp.currItem;
			if(!item || !item.img) return;

			if(mfp.st.image.verticalFit) {
				var decr = 0;
				// fix box-sizing in ie7/8
				if(mfp.isLowIE) {
					decr = parseInt(item.img.css('padding-top'), 10) + parseInt(item.img.css('padding-bottom'),10);
				}
				item.img.css('max-height', mfp.wH-decr);
			}
		},
		_onImageHasSize: function(item) {
			if(item.img) {

				item.hasSize = true;

				if(_imgInterval) {
					clearInterval(_imgInterval);
				}

				item.isCheckingImgSize = false;

				_mfpTrigger('ImageHasSize', item);

				if(item.imgHidden) {
					if(mfp.content)
						mfp.content.removeClass('mfp-loading');

					item.imgHidden = false;
				}

			}
		},

		/**
		 * Function that loops until the image has size to display elements that rely on it asap
		 */
		findImageSize: function(item) {

			var counter = 0,
				img = item.img[0],
				mfpSetInterval = function(delay) {

					if(_imgInterval) {
						clearInterval(_imgInterval);
					}
					// decelerating interval that checks for size of an image
					_imgInterval = setInterval(function() {
						if(img.naturalWidth > 0) {
							mfp._onImageHasSize(item);
							return;
						}

						if(counter > 200) {
							clearInterval(_imgInterval);
						}

						counter++;
						if(counter === 3) {
							mfpSetInterval(10);
						} else if(counter === 40) {
							mfpSetInterval(50);
						} else if(counter === 100) {
							mfpSetInterval(500);
						}
					}, delay);
				};

			mfpSetInterval(1);
		},

		getImage: function(item, template) {

			var guard = 0,

				imgSt = mfp.st.image,

				// image error handler
				onLoadError = function() {
					if(item) {
						item.img.off('.mfploader');
						if(item === mfp.currItem){
							mfp._onImageHasSize(item);
							mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
						}

						item.hasSize = true;
						item.loaded = true;
						item.loadError = true;
					}
				},

				// image load complete handler
				onLoadComplete = function() {
					if(item) {
						if (item.img[0].complete) {
							item.img.off('.mfploader');

							if(item === mfp.currItem){
								mfp._onImageHasSize(item);

								mfp.updateStatus('ready');
							}

							item.hasSize = true;
							item.loaded = true;

							_mfpTrigger('ImageLoadComplete');

						}
						else {
							// if image complete check fails 200 times (20 sec), we assume that there was an error.
							guard++;
							if(guard < 200) {
								setTimeout(onLoadComplete,100);
							} else {
								onLoadError();
							}
						}
					}
				};
				


			var el = template.find('.mfp-img');
			if(el.length) {
				var img = document.createElement('img');
				img.className = 'mfp-img';
				if(item.el && item.el.find('img').length) {
					img.alt = item.el.find('img').attr('alt');
				}
				item.img = $(img).on('load.mfploader', onLoadComplete).on('error.mfploader', onLoadError);
				img.src = item.src;

				// without clone() "error" event is not firing when IMG is replaced by new IMG
				// TODO: find a way to avoid such cloning
				if(el.is('img')) {
					item.img = item.img.clone();
				}

				img = item.img[0];
				if(img.naturalWidth > 0) {
					item.hasSize = true;
				} else if(!img.width) {
					item.hasSize = false;
				}
			}

			mfp._parseMarkup(template, {
				title: _getTitle(item),
				img_replaceWith: item.img
			}, item);

			mfp.resizeImage();

			if(item.hasSize) {
				if(_imgInterval) clearInterval(_imgInterval);

				if(item.loadError) {
					template.addClass('mfp-loading');
					mfp.updateStatus('error', imgSt.tError.replace('%url%', item.src) );
				} else {
					template.removeClass('mfp-loading');
					mfp.updateStatus('ready');
				}
				return template;
			}

			mfp.updateStatus('loading');
			item.loading = true;

			if(!item.hasSize) {
				item.imgHidden = true;
				template.addClass('mfp-loading');
				mfp.findImageSize(item);
			}

			return template;
		}
	}
});

/*>>image*/

/*>>zoom*/
var hasMozTransform,
	getHasMozTransform = function() {
		if(hasMozTransform === undefined) {
			hasMozTransform = document.createElement('p').style.MozTransform !== undefined;
		}
		return hasMozTransform;
	};

$.magnificPopup.registerModule('zoom', {

	options: {
		enabled: false,
		easing: 'ease-in-out',
		duration: 300,
		opener: function(element) {
			return element.is('img') ? element : element.find('img');
		}
	},

	proto: {

		initZoom: function() {
			var zoomSt = mfp.st.zoom,
				ns = '.zoom',
				image;

			if(!zoomSt.enabled || !mfp.supportsTransition) {
				return;
			}

			var duration = zoomSt.duration,
				getElToAnimate = function(image) {
					var newImg = image.clone().removeAttr('style').removeAttr('class').addClass('mfp-animated-image'),
						transition = 'all '+(zoomSt.duration/1000)+'s ' + zoomSt.easing,
						cssObj = {
							position: 'fixed',
							zIndex: 9999,
							left: 0,
							top: 0,
							'-webkit-backface-visibility': 'hidden'
						},
						t = 'transition';

					cssObj['-webkit-'+t] = cssObj['-moz-'+t] = cssObj['-o-'+t] = cssObj[t] = transition;

					newImg.css(cssObj);
					return newImg;
				},
				showMainContent = function() {
					mfp.content.css('visibility', 'visible');
				},
				openTimeout,
				animatedImg;

			_mfpOn('BuildControls'+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);
					mfp.content.css('visibility', 'hidden');

					// Basically, all code below does is clones existing image, puts in on top of the current one and animated it

					image = mfp._getItemToZoom();

					if(!image) {
						showMainContent();
						return;
					}

					animatedImg = getElToAnimate(image);

					animatedImg.css( mfp._getOffset() );

					mfp.wrap.append(animatedImg);

					openTimeout = setTimeout(function() {
						animatedImg.css( mfp._getOffset( true ) );
						openTimeout = setTimeout(function() {

							showMainContent();

							setTimeout(function() {
								animatedImg.remove();
								image = animatedImg = null;
								_mfpTrigger('ZoomAnimationEnded');
							}, 16); // avoid blink when switching images

						}, duration); // this timeout equals animation duration

					}, 16); // by adding this timeout we avoid short glitch at the beginning of animation


					// Lots of timeouts...
				}
			});
			_mfpOn(BEFORE_CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {

					clearTimeout(openTimeout);

					mfp.st.removalDelay = duration;

					if(!image) {
						image = mfp._getItemToZoom();
						if(!image) {
							return;
						}
						animatedImg = getElToAnimate(image);
					}

					animatedImg.css( mfp._getOffset(true) );
					mfp.wrap.append(animatedImg);
					mfp.content.css('visibility', 'hidden');

					setTimeout(function() {
						animatedImg.css( mfp._getOffset() );
					}, 16);
				}

			});

			_mfpOn(CLOSE_EVENT+ns, function() {
				if(mfp._allowZoom()) {
					showMainContent();
					if(animatedImg) {
						animatedImg.remove();
					}
					image = null;
				}
			});
		},

		_allowZoom: function() {
			return mfp.currItem.type === 'image';
		},

		_getItemToZoom: function() {
			if(mfp.currItem.hasSize) {
				return mfp.currItem.img;
			} else {
				return false;
			}
		},

		// Get element postion relative to viewport
		_getOffset: function(isLarge) {
			var el;
			if(isLarge) {
				el = mfp.currItem.img;
			} else {
				el = mfp.st.zoom.opener(mfp.currItem.el || mfp.currItem);
			}

			var offset = el.offset();
			var paddingTop = parseInt(el.css('padding-top'),10);
			var paddingBottom = parseInt(el.css('padding-bottom'),10);
			offset.top -= ( $(window).scrollTop() - paddingTop );


			/*

			Animating left + top + width/height looks glitchy in Firefox, but perfect in Chrome. And vice-versa.

			 */
			var obj = {
				width: el.width(),
				// fix Zepto height+padding issue
				height: (_isJQ ? el.innerHeight() : el[0].offsetHeight) - paddingBottom - paddingTop
			};

			// I hate to do this, but there is no another option
			if( getHasMozTransform() ) {
				obj['-moz-transform'] = obj['transform'] = 'translate(' + offset.left + 'px,' + offset.top + 'px)';
			} else {
				obj.left = offset.left;
				obj.top = offset.top;
			}
			return obj;
		}

	}
});



/*>>zoom*/

/*>>iframe*/

var IFRAME_NS = 'iframe',
	_emptyPage = '//about:blank',

	_fixIframeBugs = function(isShowing) {
		if(mfp.currTemplate[IFRAME_NS]) {
			var el = mfp.currTemplate[IFRAME_NS].find('iframe');
			if(el.length) {
				// reset src after the popup is closed to avoid "video keeps playing after popup is closed" bug
				if(!isShowing) {
					el[0].src = _emptyPage;
				}

				// IE8 black screen bug fix
				if(mfp.isIE8) {
					el.css('display', isShowing ? 'block' : 'none');
				}
			}
		}
	};

$.magnificPopup.registerModule(IFRAME_NS, {

	options: {
		markup: '<div class="mfp-iframe-scaler">'+
					'<div class="mfp-close"></div>'+
					'<iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe>'+
				'</div>',

		srcAction: 'iframe_src',

		// we don't care and support only one default type of URL by default
		patterns: {
			youtube: {
				index: 'youtube.com',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			},
			gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			}
		}
	},

	proto: {
		initIframe: function() {
			mfp.types.push(IFRAME_NS);

			_mfpOn('BeforeChange', function(e, prevType, newType) {
				if(prevType !== newType) {
					if(prevType === IFRAME_NS) {
						_fixIframeBugs(); // iframe if removed
					} else if(newType === IFRAME_NS) {
						_fixIframeBugs(true); // iframe is showing
					}
				}// else {
					// iframe source is switched, don't do anything
				//}
			});

			_mfpOn(CLOSE_EVENT + '.' + IFRAME_NS, function() {
				_fixIframeBugs();
			});
		},

		getIframe: function(item, template) {
			var embedSrc = item.src;
			var iframeSt = mfp.st.iframe;

			$.each(iframeSt.patterns, function() {
				if(embedSrc.indexOf( this.index ) > -1) {
					if(this.id) {
						if(typeof this.id === 'string') {
							embedSrc = embedSrc.substr(embedSrc.lastIndexOf(this.id)+this.id.length, embedSrc.length);
						} else {
							embedSrc = this.id.call( this, embedSrc );
						}
					}
					embedSrc = this.src.replace('%id%', embedSrc );
					return false; // break;
				}
			});

			var dataObj = {};
			if(iframeSt.srcAction) {
				dataObj[iframeSt.srcAction] = embedSrc;
			}

			mfp._parseMarkup(template, dataObj, item);

			mfp.updateStatus('ready');

			return template;
		}
	}
});



/*>>iframe*/

/*>>gallery*/
/**
 * Get looped index depending on number of slides
 */
var _getLoopedId = function(index) {
		var numSlides = mfp.items.length;
		if(index > numSlides - 1) {
			return index - numSlides;
		} else  if(index < 0) {
			return numSlides + index;
		}
		return index;
	},
	_replaceCurrTotal = function(text, curr, total) {
		return text.replace(/%curr%/gi, curr + 1).replace(/%total%/gi, total);
	};

$.magnificPopup.registerModule('gallery', {

	options: {
		enabled: false,
		arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
		preload: [0,2],
		navigateByImgClick: true,
		arrows: true,

		tPrev: 'Previous (Left arrow key)',
		tNext: 'Next (Right arrow key)',
		tCounter: '%curr% of %total%',
		
		langDir: null,
		loop: true,
	},

	proto: {
		initGallery: function() {

			var gSt = mfp.st.gallery,
				ns = '.mfp-gallery';

			mfp.direction = true; // true - next, false - prev

			if(!gSt || !gSt.enabled ) return false;
			
			if (!gSt.langDir) {
				gSt.langDir = document.dir || 'ltr';
			}

			_wrapClasses += ' mfp-gallery';

			_mfpOn(OPEN_EVENT+ns, function() {

				if(gSt.navigateByImgClick) {
					mfp.wrap.on('click'+ns, '.mfp-img', function() {
						if(mfp.items.length > 1) {
							mfp.next();
							return false;
						}
					});
				}

				_document.on('keydown'+ns, function(e) {
					if (e.keyCode === 37) {
						if (gSt.langDir === 'rtl') mfp.next();
						else mfp.prev();
					} else if (e.keyCode === 39) {
						if (gSt.langDir === 'rtl') mfp.prev();
						else mfp.next();
					}
				});

				mfp.updateGalleryButtons();

			});

			_mfpOn('UpdateStatus'+ns, function(/*e, data*/) {
				mfp.updateGalleryButtons();
			});

			_mfpOn('UpdateStatus'+ns, function(e, data) {
				if(data.text) {
					data.text = _replaceCurrTotal(data.text, mfp.currItem.index, mfp.items.length);
				}
			});

			_mfpOn(MARKUP_PARSE_EVENT+ns, function(e, element, values, item) {
				var l = mfp.items.length;
				values.counter = l > 1 ? _replaceCurrTotal(gSt.tCounter, item.index, l) : '';
			});

			_mfpOn('BuildControls' + ns, function() {
				if(mfp.items.length > 1 && gSt.arrows && !mfp.arrowLeft) {

					var arrowLeftDesc, arrowRightDesc, arrowLeftAction, arrowRightAction;

					if (gSt.langDir === 'rtl') {
						arrowLeftDesc = gSt.tNext;
						arrowRightDesc = gSt.tPrev;
						arrowLeftAction = 'next';
						arrowRightAction = 'prev';
					} else {
						arrowLeftDesc = gSt.tPrev;
						arrowRightDesc = gSt.tNext;
						arrowLeftAction = 'prev';
						arrowRightAction = 'next';
					}

					var markup     = gSt.arrowMarkup,
					    arrowLeft  = mfp.arrowLeft = $( markup.replace(/%title%/gi, arrowLeftDesc).replace(/%action%/gi, arrowLeftAction).replace(/%dir%/gi, 'left') ).addClass(PREVENT_CLOSE_CLASS),
					    arrowRight = mfp.arrowRight = $( markup.replace(/%title%/gi, arrowRightDesc).replace(/%action%/gi, arrowRightAction).replace(/%dir%/gi, 'right') ).addClass(PREVENT_CLOSE_CLASS);

					if (gSt.langDir === 'rtl') {
						mfp.arrowNext = arrowLeft;
						mfp.arrowPrev = arrowRight;
					} else {
						mfp.arrowNext = arrowRight;
						mfp.arrowPrev = arrowLeft;
					}

					arrowLeft.on('click', function() {
						if (gSt.langDir === 'rtl') mfp.next();
						else mfp.prev();
					});
					arrowRight.on('click', function() {
						if (gSt.langDir === 'rtl') mfp.prev();
						else mfp.next();
					});

					mfp.container.append(arrowLeft.add(arrowRight));

				}
			});

			_mfpOn(CHANGE_EVENT+ns, function() {
				if(mfp._preloadTimeout) clearTimeout(mfp._preloadTimeout);

				mfp._preloadTimeout = setTimeout(function() {
					mfp.preloadNearbyImages();
					mfp._preloadTimeout = null;
				}, 16);
			});


			_mfpOn(CLOSE_EVENT+ns, function() {
				_document.off(ns);
				mfp.wrap.off('click'+ns);
				mfp.arrowRight = mfp.arrowLeft = null;
			});

		},
		next: function() {
			var newIndex = _getLoopedId(mfp.index + 1);
			if (!mfp.st.gallery.loop && newIndex === 0 ) return false;
			mfp.direction = true;
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		prev: function() {
			var newIndex = mfp.index - 1;
			if (!mfp.st.gallery.loop && newIndex < 0) return false;
			mfp.direction = false;
			mfp.index = _getLoopedId(newIndex);
			mfp.updateItemHTML();
		},
		goTo: function(newIndex) {
			mfp.direction = (newIndex >= mfp.index);
			mfp.index = newIndex;
			mfp.updateItemHTML();
		},
		preloadNearbyImages: function() {
			var p = mfp.st.gallery.preload,
				preloadBefore = Math.min(p[0], mfp.items.length),
				preloadAfter = Math.min(p[1], mfp.items.length),
				i;

			for(i = 1; i <= (mfp.direction ? preloadAfter : preloadBefore); i++) {
				mfp._preloadItem(mfp.index+i);
			}
			for(i = 1; i <= (mfp.direction ? preloadBefore : preloadAfter); i++) {
				mfp._preloadItem(mfp.index-i);
			}
		},
		_preloadItem: function(index) {
			index = _getLoopedId(index);

			if(mfp.items[index].preloaded) {
				return;
			}

			var item = mfp.items[index];
			if(!item.parsed) {
				item = mfp.parseEl( index );
			}

			_mfpTrigger('LazyLoad', item);

			if(item.type === 'image') {
				item.img = $('<img class="mfp-img" />').on('load.mfploader', function() {
					item.hasSize = true;
				}).on('error.mfploader', function() {
					item.hasSize = true;
					item.loadError = true;
					_mfpTrigger('LazyLoadError', item);
				}).attr('src', item.src);
			}


			item.preloaded = true;
		},

		/**
		 * Show/hide the gallery prev/next buttons if we're at the start/end, if looping is turned off
		 * Added by Joloco for Veg
		 */
		updateGalleryButtons: function() {

			if ( !mfp.st.gallery.loop && typeof mfp.arrowPrev === 'object' && mfp.arrowPrev !== null) {

				if (mfp.index === 0) mfp.arrowPrev.hide();
				else mfp.arrowPrev.show();

				if (mfp.index === (mfp.items.length - 1)) mfp.arrowNext.hide();
				else mfp.arrowNext.show();

			}

		},

	}

});


/*>>gallery*/

/*>>retina*/

var RETINA_NS = 'retina';

$.magnificPopup.registerModule(RETINA_NS, {
	options: {
		replaceSrc: function(item) {
			return item.src.replace(/\.\w+$/, function(m) { return '@2x' + m; });
		},
		ratio: 1 // Function or number.  Set to 1 to disable.
	},
	proto: {
		initRetina: function() {
			if(window.devicePixelRatio > 1) {

				var st = mfp.st.retina,
					ratio = st.ratio;

				ratio = !isNaN(ratio) ? ratio : ratio();

				if(ratio > 1) {
					_mfpOn('ImageHasSize' + '.' + RETINA_NS, function(e, item) {
						item.img.css({
							'max-width': item.img[0].naturalWidth / ratio,
							'width': '100%'
						});
					});
					_mfpOn('ElementParse' + '.' + RETINA_NS, function(e, item) {
						item.src = st.replaceSrc(item, ratio);
					});
				}
			}

		}
	}
});

/*>>retina*/
 _checkInstance(); }));

/**
 * I would do this in CSS but we need to add in the SVG
 * symbol anyway and we only want to show the custom
 * checkbox if this code is run so better to do it here
 *
 * @author Neil Brayfield <neil@d3r.com>
 */
$.fn.checkReplace = function() {
    $(this).each(function() {
        var current = $(this);
        current.wrap('<div class="check-replace"></div>').hide();

        var wrap = $(this).parent();

        wrap.append(
            '<svg class="icon-tick-fancy">' +
                '<use xlink:href="'+base+'/images/svg-symbols.svg#icon-tick-fancy" />' +
            '</svg>'
        );

        current.on('change', function (e) {

            if (current.prop('checked')) {
                wrap.addClass('check-replace--active');
            } else {
                wrap.removeClass('check-replace--active');
            }

            return true;
        });

        $(this).trigger('change', [true]);
    });
};

!function(root, factory) {
    "function" == typeof define && define.amd ? // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return root.svg4everybody = factory();
    }) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

svg4everybody();

/*!
 * pickadate.js v3.6.4, 2019/05/25
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */

(function ( factory ) {

    // AMD.
    if ( typeof define == 'function' && define.amd )
        define( 'picker', ['jquery'], factory )

    // Node.js/browserify.
    else if ( typeof exports == 'object' )
        module.exports = factory( require('jquery') )

    // Browser globals.
    else if ( typeof window == 'object' )
        window.Picker = factory( jQuery )
    
    else this.Picker = factory( jQuery )

}(function( $ ) {

var $window = $( window )
var $document = $( document )
var $html = $( document.documentElement )
var supportsTransitions = document.documentElement.style.transition != null


/**
 * The picker constructor that creates a blank picker.
 */
function PickerConstructor( ELEMENT, NAME, COMPONENT, OPTIONS ) {

    // If there’s no element, return the picker constructor.
    if ( !ELEMENT ) return PickerConstructor


    var
        IS_DEFAULT_THEME = false,


        // The state of the picker.
        STATE = {
            id: ELEMENT.id || 'P' + Math.abs( ~~(Math.random() * new Date()) ),
            handlingOpen: false,
        },


        // Merge the defaults and options passed.
        SETTINGS = COMPONENT ? $.extend( true, {}, COMPONENT.defaults, OPTIONS ) : OPTIONS || {},


        // Merge the default classes with the settings classes.
        CLASSES = $.extend( {}, PickerConstructor.klasses(), SETTINGS.klass ),


        // The element node wrapper into a jQuery object.
        $ELEMENT = $( ELEMENT ),


        // Pseudo picker constructor.
        PickerInstance = function() {
            return this.start()
        },


        // The picker prototype.
        P = PickerInstance.prototype = {

            constructor: PickerInstance,

            $node: $ELEMENT,


            /**
             * Initialize everything
             */
            start: function() {

                // If it’s already started, do nothing.
                if ( STATE && STATE.start ) return P


                // Update the picker states.
                STATE.methods = {}
                STATE.start = true
                STATE.open = false
                STATE.type = ELEMENT.type


                // Confirm focus state, convert into text input to remove UA stylings,
                // and set as readonly to prevent keyboard popup.
                ELEMENT.autofocus = ELEMENT == getActiveElement()
                ELEMENT.readOnly = !SETTINGS.editable
                ELEMENT.id = ELEMENT.id || STATE.id
                if ( ELEMENT.type != 'text' ) {
                    ELEMENT.type = 'text'
                }


                // Create a new picker component with the settings.
                P.component = new COMPONENT(P, SETTINGS)


                // Create the picker root and then prepare it.
                P.$root = $( '<div class="' + CLASSES.picker + '" id="' + ELEMENT.id + '_root" />' )
                prepareElementRoot()


                // Create the picker holder and then prepare it.
                P.$holder = $( createWrappedComponent() ).appendTo( P.$root )
                prepareElementHolder()


                // If there’s a format for the hidden input element, create the element.
                if ( SETTINGS.formatSubmit ) {
                    prepareElementHidden()
                }


                // Prepare the input element.
                prepareElement()


                // Insert the hidden input as specified in the settings.
                if ( SETTINGS.containerHidden ) $( SETTINGS.containerHidden ).append( P._hidden )
                else $ELEMENT.after( P._hidden )


                // Insert the root as specified in the settings.
                if ( SETTINGS.container ) $( SETTINGS.container ).append( P.$root )
                else $ELEMENT.after( P.$root )


                // Bind the default component and settings events.
                P.on({
                    start: P.component.onStart,
                    render: P.component.onRender,
                    stop: P.component.onStop,
                    open: P.component.onOpen,
                    close: P.component.onClose,
                    set: P.component.onSet
                }).on({
                    start: SETTINGS.onStart,
                    render: SETTINGS.onRender,
                    stop: SETTINGS.onStop,
                    open: SETTINGS.onOpen,
                    close: SETTINGS.onClose,
                    set: SETTINGS.onSet
                })


                // Once we’re all set, check the theme in use.
                IS_DEFAULT_THEME = isUsingDefaultTheme( P.$holder[0] )


                // If the element has autofocus, open the picker.
                if ( ELEMENT.autofocus ) {
                    P.open()
                }


                // Trigger queued the “start” and “render” events.
                return P.trigger( 'start' ).trigger( 'render' )
            }, //start


            /**
             * Render a new picker
             */
            render: function( entireComponent ) {

                // Insert a new component holder in the root or box.
                if ( entireComponent ) {
                    P.$holder = $( createWrappedComponent() )
                    prepareElementHolder()
                    P.$root.html( P.$holder )
                }
                else P.$root.find( '.' + CLASSES.box ).html( P.component.nodes( STATE.open ) )

                // Trigger the queued “render” events.
                return P.trigger( 'render' )
            }, //render


            /**
             * Destroy everything
             */
            stop: function() {

                // If it’s already stopped, do nothing.
                if ( !STATE.start ) return P

                // Then close the picker.
                P.close()

                // Remove the hidden field.
                if ( P._hidden ) {
                    P._hidden.parentNode.removeChild( P._hidden )
                }

                // Remove the root.
                P.$root.remove()

                // Remove the input class, remove the stored data, and unbind
                // the events (after a tick for IE - see `P.close`).
                $ELEMENT.removeClass( CLASSES.input ).removeData( NAME )
                setTimeout( function() {
                    $ELEMENT.off( '.' + STATE.id )
                }, 0)

                // Restore the element state
                ELEMENT.type = STATE.type
                ELEMENT.readOnly = false

                // Trigger the queued “stop” events.
                P.trigger( 'stop' )

                // Reset the picker states.
                STATE.methods = {}
                STATE.start = false

                return P
            }, //stop


            /**
             * Open up the picker
             */
            open: function( dontGiveFocus ) {

                // If it’s already open, do nothing.
                if ( STATE.open ) return P

                // Add the “active” class.
                $ELEMENT.addClass( CLASSES.active )
                aria( ELEMENT, 'expanded', true )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So add the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Add the “opened” class to the picker root.
                    P.$root.addClass( CLASSES.opened )
                    aria( P.$root[0], 'hidden', false )

                }, 0 )

                // If we have to give focus, bind the element and doc events.
                if ( dontGiveFocus !== false ) {

                    // Set it as open.
                    STATE.open = true

                    // Prevent the page from scrolling.
                    if ( IS_DEFAULT_THEME ) {
                        $('body').
                            css( 'overflow', 'hidden' ).
                            css( 'padding-right', '+=' + getScrollbarWidth() )
                    }

                    // Pass focus to the root element’s jQuery object.
                    focusPickerOnceOpened()

                    // Bind the document events.
                    $document.on( 'click.' + STATE.id + ' focusin.' + STATE.id, function( event ) {
                        // If the picker is currently midway through processing
                        // the opening sequence of events then don't handle clicks
                        // on any part of the DOM. This is caused by a bug in Chrome 73
                        // where a click event is being generated with the incorrect
                        // path in it.
                        // In short, if someone does a click that finishes after the
                        // new element is created then the path contains only the
                        // parent element and not the input element itself.
                        if (STATE.handlingOpen) {
                          return;
                        }

                        var target = getRealEventTarget( event, ELEMENT )

                        // If the target of the event is not the element, close the picker picker.
                        // * Don’t worry about clicks or focusins on the root because those don’t bubble up.
                        //   Also, for Firefox, a click on an `option` element bubbles up directly
                        //   to the doc. So make sure the target wasn't the doc.
                        // * In Firefox stopPropagation() doesn’t prevent right-click events from bubbling,
                        //   which causes the picker to unexpectedly close when right-clicking it. So make
                        //   sure the event wasn’t a right-click.
                        // * In Chrome 62 and up, password autofill causes a simulated focusin event which
                        //   closes the picker.
                        if ( ! event.isSimulated && target != ELEMENT && target != document && event.which != 3 ) {

                            // If the target was the holder that covers the screen,
                            // keep the element focused to maintain tabindex.
                            P.close( target === P.$holder[0] )
                        }

                    }).on( 'keydown.' + STATE.id, function( event ) {

                        var
                            // Get the keycode.
                            keycode = event.keyCode,

                            // Translate that to a selection change.
                            keycodeToMove = P.component.key[ keycode ],

                            // Grab the target.
                            target = getRealEventTarget( event, ELEMENT )


                        // On escape, close the picker and give focus.
                        if ( keycode == 27 ) {
                            P.close( true )
                        }


                        // Check if there is a key movement or “enter” keypress on the element.
                        else if ( target == P.$holder[0] && ( keycodeToMove || keycode == 13 ) ) {

                            // Prevent the default action to stop page movement.
                            event.preventDefault()

                            // Trigger the key movement action.
                            if ( keycodeToMove ) {
                                PickerConstructor._.trigger( P.component.key.go, P, [ PickerConstructor._.trigger( keycodeToMove ) ] )
                            }

                            // On “enter”, if the highlighted item isn’t disabled, set the value and close.
                            else if ( !P.$root.find( '.' + CLASSES.highlighted ).hasClass( CLASSES.disabled ) ) {
                                P.set( 'select', P.component.item.highlight )
                                if ( SETTINGS.closeOnSelect ) {
                                    P.close( true )
                                }
                            }
                        }


                        // If the target is within the root and “enter” is pressed,
                        // prevent the default action and trigger a click on the target instead.
                        else if ( $.contains( P.$root[0], target ) && keycode == 13 ) {
                            event.preventDefault()
                            target.click()
                        }
                    })
                }

                // Trigger the queued “open” events.
                return P.trigger( 'open' )
            }, //open


            /**
             * Close the picker
             */
            close: function( giveFocus ) {

                // If we need to give focus, do it before changing states.
                if ( giveFocus ) {
                    if ( SETTINGS.editable ) {
                        ELEMENT.focus()
                    }
                    else {
                        // ....ah yes! It would’ve been incomplete without a crazy workaround for IE :|
                        // The focus is triggered *after* the close has completed - causing it
                        // to open again. So unbind and rebind the event at the next tick.
                        P.$holder.off( 'focus.toOpen' ).focus()
                        setTimeout( function() {
                            P.$holder.on( 'focus.toOpen', handleFocusToOpenEvent )
                        }, 0 )
                    }
                }

                // Remove the “active” class.
                $ELEMENT.removeClass( CLASSES.active )
                aria( ELEMENT, 'expanded', false )

                // * A Firefox bug, when `html` has `overflow:hidden`, results in
                //   killing transitions :(. So remove the “opened” state on the next tick.
                //   Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=625289
                setTimeout( function() {

                    // Remove the “opened” and “focused” class from the picker root.
                    P.$root.removeClass( CLASSES.opened + ' ' + CLASSES.focused )
                    aria( P.$root[0], 'hidden', true )

                }, 0 )

                // If it’s already closed, do nothing more.
                if ( !STATE.open ) return P

                // Set it as closed.
                STATE.open = false

                // Allow the page to scroll.
                if ( IS_DEFAULT_THEME ) {
                    $('body').
                        css( 'overflow', '' ).
                        css( 'padding-right', '-=' + getScrollbarWidth() )
                }

                // Unbind the document events.
                $document.off( '.' + STATE.id )

                // Trigger the queued “close” events.
                return P.trigger( 'close' )
            }, //close


            /**
             * Clear the values
             */
            clear: function( options ) {
                return P.set( 'clear', null, options )
            }, //clear


            /**
             * Set something
             */
            set: function( thing, value, options ) {

                var thingItem, thingValue,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                // Make sure we have usable options.
                options = thingIsObject && $.isPlainObject( value ) ? value : options || {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = value
                    }

                    // Go through the things of items to set.
                    for ( thingItem in thingObject ) {

                        // Grab the value of the thing.
                        thingValue = thingObject[ thingItem ]

                        // First, if the item exists and there’s a value, set it.
                        if ( thingItem in P.component.item ) {
                            if ( thingValue === undefined ) thingValue = null
                            P.component.set( thingItem, thingValue, options )
                        }

                        // Then, check to update the element value and broadcast a change.
                        if ( ( thingItem == 'select' || thingItem == 'clear' ) && SETTINGS.updateInput ) {
                            $ELEMENT.
                                val( thingItem == 'clear' ? '' : P.get( thingItem, SETTINGS.format ) ).
                                trigger( 'change' )
                        }
                    }

                    // Render a new picker.
                    P.render()
                }

                // When the method isn’t muted, trigger queued “set” events and pass the `thingObject`.
                return options.muted ? P : P.trigger( 'set', thingObject )
            }, //set


            /**
             * Get something
             */
            get: function( thing, format ) {

                // Make sure there’s something to get.
                thing = thing || 'value'

                // If a picker state exists, return that.
                if ( STATE[ thing ] != null ) {
                    return STATE[ thing ]
                }

                // Return the submission value, if that.
                if ( thing == 'valueSubmit' ) {
                    if ( P._hidden ) {
                        return P._hidden.value
                    }
                    thing = 'value'
                }

                // Return the value, if that.
                if ( thing == 'value' ) {
                    return ELEMENT.value
                }

                // Check if a component item exists, return that.
                if ( thing in P.component.item ) {
                    if ( typeof format == 'string' ) {
                        var thingValue = P.component.get( thing )
                        return thingValue ?
                            PickerConstructor._.trigger(
                                P.component.formats.toString,
                                P.component,
                                [ format, thingValue ]
                            ) : ''
                    }
                    return P.component.get( thing )
                }
            }, //get



            /**
             * Bind events on the things.
             */
            on: function( thing, method, internal ) {

                var thingName, thingMethod,
                    thingIsObject = $.isPlainObject( thing ),
                    thingObject = thingIsObject ? thing : {}

                if ( thing ) {

                    // If the thing isn’t an object, make it one.
                    if ( !thingIsObject ) {
                        thingObject[ thing ] = method
                    }

                    // Go through the things to bind to.
                    for ( thingName in thingObject ) {

                        // Grab the method of the thing.
                        thingMethod = thingObject[ thingName ]

                        // If it was an internal binding, prefix it.
                        if ( internal ) {
                            thingName = '_' + thingName
                        }

                        // Make sure the thing methods collection exists.
                        STATE.methods[ thingName ] = STATE.methods[ thingName ] || []

                        // Add the method to the relative method collection.
                        STATE.methods[ thingName ].push( thingMethod )
                    }
                }

                return P
            }, //on



            /**
             * Unbind events on the things.
             */
            off: function() {
                var i, thingName,
                    names = arguments;
                for ( i = 0, namesCount = names.length; i < namesCount; i += 1 ) {
                    thingName = names[i]
                    if ( thingName in STATE.methods ) {
                        delete STATE.methods[thingName]
                    }
                }
                return P
            },


            /**
             * Fire off method events.
             */
            trigger: function( name, data ) {
                var _trigger = function( name ) {
                    var methodList = STATE.methods[ name ]
                    if ( methodList ) {
                        methodList.map( function( method ) {
                            PickerConstructor._.trigger( method, P, [ data ] )
                        })
                    }
                }
                _trigger( '_' + name )
                _trigger( name )
                return P
            } //trigger
        } //PickerInstance.prototype


    /**
     * Wrap the picker holder components together.
     */
    function createWrappedComponent() {

        // Create a picker wrapper holder
        return PickerConstructor._.node( 'div',

            // Create a picker wrapper node
            PickerConstructor._.node( 'div',

                // Create a picker frame
                PickerConstructor._.node( 'div',

                    // Create a picker box node
                    PickerConstructor._.node( 'div',

                        // Create the components nodes.
                        P.component.nodes( STATE.open ),

                        // The picker box class
                        CLASSES.box
                    ),

                    // Picker wrap class
                    CLASSES.wrap
                ),

                // Picker frame class
                CLASSES.frame
            ),

            // Picker holder class
            CLASSES.holder,

            'tabindex="-1"'
        ) //endreturn
    } //createWrappedComponent

    /**
     * Prepare the input element with all bindings.
     */
    function prepareElement() {

        $ELEMENT.

            // Store the picker data by component name.
            data(NAME, P).

            // Add the “input” class name.
            addClass(CLASSES.input).

            // If there’s a `data-value`, update the value of the element.
            val( $ELEMENT.data('value') ?
                P.get('select', SETTINGS.format) :
                ELEMENT.value
            ).

            // On focus/click, open the picker.
            on( 'focus.' + STATE.id + ' click.' + STATE.id,
                function(event) {
                    event.preventDefault()
                    P.open()
                }
            )

            // Mousedown handler to capture when the user starts interacting
            // with the picker. This is used in working around a bug in Chrome 73.
            .on('mousedown', function() {
              STATE.handlingOpen = true;
              var handler = function() {
                // By default mouseup events are fired before a click event.
                // By using a timeout we can force the mouseup to be handled
                // after the corresponding click event is handled.
                setTimeout(function() {
                  $(document).off('mouseup', handler);
                  STATE.handlingOpen = false;
                }, 0);
              };
              $(document).on('mouseup', handler);
            });


        // Only bind keydown events if the element isn’t editable.
        if ( !SETTINGS.editable ) {

            $ELEMENT.

                // Handle keyboard event based on the picker being opened or not.
                on( 'keydown.' + STATE.id, handleKeydownEvent )
        }


        // Update the aria attributes.
        aria(ELEMENT, {
            haspopup: true,
            expanded: false,
            readonly: false,
            owns: ELEMENT.id + '_root'
        })
    }


    /**
     * Prepare the root picker element with all bindings.
     */
    function prepareElementRoot() {
        aria( P.$root[0], 'hidden', true )
    }


     /**
      * Prepare the holder picker element with all bindings.
      */
    function prepareElementHolder() {

        P.$holder.

            on({

                // For iOS8.
                keydown: handleKeydownEvent,

                'focus.toOpen': handleFocusToOpenEvent,

                blur: function() {
                    // Remove the “target” class.
                    $ELEMENT.removeClass( CLASSES.target )
                },

                // When something within the holder is focused, stop from bubbling
                // to the doc and remove the “focused” state from the root.
                focusin: function( event ) {
                    P.$root.removeClass( CLASSES.focused )
                    event.stopPropagation()
                },

                // When something within the holder is clicked, stop it
                // from bubbling to the doc.
                'mousedown click': function( event ) {

                    var target = getRealEventTarget( event, ELEMENT )

                    // Make sure the target isn’t the root holder so it can bubble up.
                    if ( target != P.$holder[0] ) {

                        event.stopPropagation()

                        // * For mousedown events, cancel the default action in order to
                        //   prevent cases where focus is shifted onto external elements
                        //   when using things like jQuery mobile or MagnificPopup (ref: #249 & #120).
                        //   Also, for Firefox, don’t prevent action on the `option` element.
                        if ( event.type == 'mousedown' && !$( target ).is( 'input, select, textarea, button, option' )) {

                            event.preventDefault()

                            // Re-focus onto the holder so that users can click away
                            // from elements focused within the picker.
                            P.$holder.eq(0).focus()
                        }
                    }
                }

            }).

            // If there’s a click on an actionable element, carry out the actions.
            on( 'click', '[data-pick], [data-nav], [data-clear], [data-close]', function() {

                var $target = $( this ),
                    targetData = $target.data(),
                    targetDisabled = $target.hasClass( CLASSES.navDisabled ) || $target.hasClass( CLASSES.disabled ),

                    // * For IE, non-focusable elements can be active elements as well
                    //   (http://stackoverflow.com/a/2684561).
                    activeElement = getActiveElement()
                    activeElement = activeElement && ( (activeElement.type || activeElement.href ) ? activeElement : null);

                // If it’s disabled or nothing inside is actively focused, re-focus the element.
                if ( targetDisabled || activeElement && !$.contains( P.$root[0], activeElement ) ) {
                    P.$holder.eq(0).focus()
                }

                // If something is superficially changed, update the `highlight` based on the `nav`.
                if ( !targetDisabled && targetData.nav ) {
                    P.set( 'highlight', P.component.item.highlight, { nav: targetData.nav } )
                }

                // If something is picked, set `select` then close with focus.
                else if ( !targetDisabled && 'pick' in targetData ) {
                    P.set( 'select', targetData.pick )
                    if ( SETTINGS.closeOnSelect ) {
                        P.close( true )
                    }
                }

                // If a “clear” button is pressed, empty the values and close with focus.
                else if ( targetData.clear ) {
                    P.clear()
                    if ( SETTINGS.closeOnClear ) {
                        P.close( true )
                    }
                }

                else if ( targetData.close ) {
                    P.close( true )
                }

            }) //P.$holder

    }


     /**
      * Prepare the hidden input element along with all bindings.
      */
    function prepareElementHidden() {

        var name

        if ( SETTINGS.hiddenName === true ) {
            name = ELEMENT.name
            ELEMENT.name = ''
        }
        else {
            name = [
                typeof SETTINGS.hiddenPrefix == 'string' ? SETTINGS.hiddenPrefix : '',
                typeof SETTINGS.hiddenSuffix == 'string' ? SETTINGS.hiddenSuffix : '_submit'
            ]
            name = name[0] + ELEMENT.name + name[1]
        }

        P._hidden = $(
            '<input ' +
            'type=hidden ' +

            // Create the name using the original input’s with a prefix and suffix.
            'name="' + name + '"' +

            // If the element has a value, set the hidden value as well.
            (
                $ELEMENT.data('value') || ELEMENT.value ?
                    ' value="' + P.get('select', SETTINGS.formatSubmit) + '"' :
                    ''
            ) +
            '>'
        )[0]

        $ELEMENT.

            // If the value changes, update the hidden input with the correct format.
            on('change.' + STATE.id, function() {
                P._hidden.value = ELEMENT.value ?
                    P.get('select', SETTINGS.formatSubmit) :
                    ''
            })
    }


    // Wait for transitions to end before focusing the holder. Otherwise, while
    // using the `container` option, the view jumps to the container.
    function focusPickerOnceOpened() {

        if (IS_DEFAULT_THEME && supportsTransitions) {
            P.$holder.find('.' + CLASSES.frame).one('transitionend', function() {
                P.$holder.eq(0).focus()
            })
        }
        else {
            setTimeout(function() {
                P.$holder.eq(0).focus()
            }, 0)
        }
    }


    function handleFocusToOpenEvent(event) {

        // Stop the event from propagating to the doc.
        event.stopPropagation()

        // Add the “target” class.
        $ELEMENT.addClass( CLASSES.target )

        // Add the “focused” class to the root.
        P.$root.addClass( CLASSES.focused )

        // And then finally open the picker.
        P.open()
    }


    // For iOS8.
    function handleKeydownEvent( event ) {

        var keycode = event.keyCode,

            // Check if one of the delete keys was pressed.
            isKeycodeDelete = /^(8|46)$/.test(keycode)

        // For some reason IE clears the input value on “escape”.
        if ( keycode == 27 ) {
            P.close( true )
            return false
        }

        // Check if `space` or `delete` was pressed or the picker is closed with a key movement.
        if ( keycode == 32 || isKeycodeDelete || !STATE.open && P.component.key[keycode] ) {

            // Prevent it from moving the page and bubbling to doc.
            event.preventDefault()
            event.stopPropagation()

            // If `delete` was pressed, clear the values and close the picker.
            // Otherwise open the picker.
            if ( isKeycodeDelete ) { P.clear().close() }
            else { P.open() }
        }
    }


    // Return a new picker instance.
    return new PickerInstance()
} //PickerConstructor



/**
 * The default classes and prefix to use for the HTML classes.
 */
PickerConstructor.klasses = function( prefix ) {
    prefix = prefix || 'picker'
    return {

        picker: prefix,
        opened: prefix + '--opened',
        focused: prefix + '--focused',

        input: prefix + '__input',
        active: prefix + '__input--active',
        target: prefix + '__input--target',

        holder: prefix + '__holder',

        frame: prefix + '__frame',
        wrap: prefix + '__wrap',

        box: prefix + '__box'
    }
} //PickerConstructor.klasses



/**
 * Check if the default theme is being used.
 */
function isUsingDefaultTheme( element ) {

    var theme,
        prop = 'position'

    // For IE.
    if ( element.currentStyle ) {
        theme = element.currentStyle[prop]
    }

    // For normal browsers.
    else if ( window.getComputedStyle ) {
        theme = getComputedStyle( element )[prop]
    }

    return theme == 'fixed'
}



/**
 * Get the width of the browser’s scrollbar.
 * Taken from: https://github.com/VodkaBears/Remodal/blob/master/src/jquery.remodal.js
 */
function getScrollbarWidth() {

    if ( $html.height() <= $window.height() ) {
        return 0
    }

    var $outer = $( '<div style="visibility:hidden;width:100px" />' ).
        appendTo( 'body' )

    // Get the width without scrollbars.
    var widthWithoutScroll = $outer[0].offsetWidth

    // Force adding scrollbars.
    $outer.css( 'overflow', 'scroll' )

    // Add the inner div.
    var $inner = $( '<div style="width:100%" />' ).appendTo( $outer )

    // Get the width with scrollbars.
    var widthWithScroll = $inner[0].offsetWidth

    // Remove the divs.
    $outer.remove()

    // Return the difference between the widths.
    return widthWithoutScroll - widthWithScroll
}



/**
 * Get the target element from the event.
 * If ELEMENT is supplied and present in the event path (ELEMENT is ancestor of the target),
 * returns ELEMENT instead
 */
function getRealEventTarget( event, ELEMENT ) {

    var path = []

    if ( event.path ) {
        path = event.path
    }

    if ( event.originalEvent && event.originalEvent.path ) {
        path = event.originalEvent.path
    }

    if ( path && path.length > 0 ) {
        if ( ELEMENT && path.indexOf( ELEMENT ) >= 0 ) {
            return ELEMENT
        } else {
            return path[0]
        }
    }

    return event.target
}

/**
 * PickerConstructor helper methods.
 */
PickerConstructor._ = {

    /**
     * Create a group of nodes. Expects:
     * `
        {
            min:    {Integer},
            max:    {Integer},
            i:      {Integer},
            node:   {String},
            item:   {Function}
        }
     * `
     */
    group: function( groupObject ) {

        var
            // Scope for the looped object
            loopObjectScope,

            // Create the nodes list
            nodesList = '',

            // The counter starts from the `min`
            counter = PickerConstructor._.trigger( groupObject.min, groupObject )


        // Loop from the `min` to `max`, incrementing by `i`
        for ( ; counter <= PickerConstructor._.trigger( groupObject.max, groupObject, [ counter ] ); counter += groupObject.i ) {

            // Trigger the `item` function within scope of the object
            loopObjectScope = PickerConstructor._.trigger( groupObject.item, groupObject, [ counter ] )

            // Splice the subgroup and create nodes out of the sub nodes
            nodesList += PickerConstructor._.node(
                groupObject.node,
                loopObjectScope[ 0 ],   // the node
                loopObjectScope[ 1 ],   // the classes
                loopObjectScope[ 2 ]    // the attributes
            )
        }

        // Return the list of nodes
        return nodesList
    }, //group


    /**
     * Create a dom node string
     */
    node: function( wrapper, item, klass, attribute ) {

        // If the item is false-y, just return an empty string
        if ( !item ) return ''

        // If the item is an array, do a join
        item = $.isArray( item ) ? item.join( '' ) : item

        // Check for the class
        klass = klass ? ' class="' + klass + '"' : ''

        // Check for any attributes
        attribute = attribute ? ' ' + attribute : ''

        // Return the wrapped item
        return '<' + wrapper + klass + attribute + '>' + item + '</' + wrapper + '>'
    }, //node


    /**
     * Lead numbers below 10 with a zero.
     */
    lead: function( number ) {
        return ( number < 10 ? '0': '' ) + number
    },


    /**
     * Trigger a function otherwise return the value.
     */
    trigger: function( callback, scope, args ) {
        return typeof callback == 'function' ? callback.apply( scope, args || [] ) : callback
    },


    /**
     * If the second character is a digit, length is 2 otherwise 1.
     */
    digits: function( string ) {
        return ( /\d/ ).test( string[ 1 ] ) ? 2 : 1
    },


    /**
     * Tell if something is a date object.
     */
    isDate: function( value ) {
        return {}.toString.call( value ).indexOf( 'Date' ) > -1 && this.isInteger( value.getDate() )
    },


    /**
     * Tell if something is an integer.
     */
    isInteger: function( value ) {
        return {}.toString.call( value ).indexOf( 'Number' ) > -1 && value % 1 === 0
    },


    /**
     * Create ARIA attribute strings.
     */
    ariaAttr: ariaAttr
} //PickerConstructor._



/**
 * Extend the picker with a component and defaults.
 */
PickerConstructor.extend = function( name, Component ) {

    // Extend jQuery.
    $.fn[ name ] = function( options, action ) {

        // Grab the component data.
        var componentData = this.data( name )

        // If the picker is requested, return the data object.
        if ( options == 'picker' ) {
            return componentData
        }

        // If the component data exists and `options` is a string, carry out the action.
        if ( componentData && typeof options == 'string' ) {
            return PickerConstructor._.trigger( componentData[ options ], componentData, [ action ] )
        }

        // Otherwise go through each matched element and if the component
        // doesn’t exist, create a new picker using `this` element
        // and merging the defaults and options with a deep copy.
        return this.each( function() {
            var $this = $( this )
            if ( !$this.data( name ) ) {
                new PickerConstructor( this, name, Component, options )
            }
        })
    }

    // Set the defaults.
    $.fn[ name ].defaults = Component.defaults
} //PickerConstructor.extend



function aria(element, attribute, value) {
    if ( $.isPlainObject(attribute) ) {
        for ( var key in attribute ) {
            ariaSet(element, key, attribute[key])
        }
    }
    else {
        ariaSet(element, attribute, value)
    }
}
function ariaSet(element, attribute, value) {
    element.setAttribute(
        (attribute == 'role' ? '' : 'aria-') + attribute,
        value
    )
}
function ariaAttr(attribute, data) {
    if ( !$.isPlainObject(attribute) ) {
        attribute = { attribute: data }
    }
    data = ''
    for ( var key in attribute ) {
        var attr = (key == 'role' ? '' : 'aria-') + key,
            attrVal = attribute[key]
        data += attrVal == null ? '' : attr + '="' + attribute[key] + '"'
    }
    return data
}

// IE8 bug throws an error for activeElements within iframes.
function getActiveElement() {
    try {
        return document.activeElement
    } catch ( err ) { }
}



// Expose the picker constructor.
return PickerConstructor


}));

/*!
 * Date picker for pickadate.js v3.6.4
 * http://amsul.github.io/pickadate.js/date.htm
 */

(function ( factory ) {

    // AMD.
    if ( typeof define == 'function' && define.amd )
        define( ['./picker', 'jquery'], factory )

    // Node.js/browserify.
    else if ( typeof exports == 'object' )
        module.exports = factory( require('./picker.js'), require('jquery') )

    // Browser globals.
    else factory( Picker, jQuery )

}(function( Picker, $ ) {


/**
 * Globals and constants
 */
var DAYS_IN_WEEK = 7,
    WEEKS_IN_CALENDAR = 6,
    _ = Picker._



/**
 * The date picker constructor
 */
function DatePicker( picker, settings ) {

    var calendar = this,
        element = picker.$node[ 0 ],
        elementValue = element.value,
        elementDataValue = picker.$node.data( 'value' ),
        valueString = elementDataValue || elementValue,
        formatString = elementDataValue ? settings.formatSubmit : settings.format,
        isRTL = function() {

            return element.currentStyle ?

                // For IE.
                element.currentStyle.direction == 'rtl' :

                // For normal browsers.
                getComputedStyle( picker.$root[0] ).direction == 'rtl'
        }

    calendar.settings = settings
    calendar.$node = picker.$node

    // The queue of methods that will be used to build item objects.
    calendar.queue = {
        min: 'measure create',
        max: 'measure create',
        now: 'now create',
        select: 'parse create validate',
        highlight: 'parse navigate create validate',
        view: 'parse create validate viewset',
        disable: 'deactivate',
        enable: 'activate'
    }

    // The component's item object.
    calendar.item = {}

    calendar.item.clear = null
    calendar.item.disable = ( settings.disable || [] ).slice( 0 )
    calendar.item.enable = -(function( collectionDisabled ) {
        return collectionDisabled[ 0 ] === true ? collectionDisabled.shift() : -1
    })( calendar.item.disable )

    calendar.
        set( 'min', settings.min ).
        set( 'max', settings.max ).
        set( 'now' )

    // When there’s a value, set the `select`, which in turn
    // also sets the `highlight` and `view`.
    if ( valueString ) {
        calendar.set( 'select', valueString, {
            format: formatString,
            defaultValue: true
        })
    }

    // If there’s no value, default to highlighting “today”.
    else {
        calendar.
            set( 'select', null ).
            set( 'highlight', calendar.item.now )
    }


    // The keycode to movement mapping.
    calendar.key = {
        40: 7, // Down
        38: -7, // Up
        39: function() { return isRTL() ? -1 : 1 }, // Right
        37: function() { return isRTL() ? 1 : -1 }, // Left
        go: function( timeChange ) {
            var highlightedObject = calendar.item.highlight,
                targetDate = new Date( highlightedObject.year, highlightedObject.month, highlightedObject.date + timeChange )
            calendar.set(
                'highlight',
                targetDate,
                { interval: timeChange }
            )
            this.render()
        }
    }


    // Bind some picker events.
    picker.
        on( 'render', function() {
            picker.$root.find( '.' + settings.klass.selectMonth ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ picker.get( 'view' ).year, value, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectMonth ).trigger( 'focus' )
                }
            })
            picker.$root.find( '.' + settings.klass.selectYear ).on( 'change', function() {
                var value = this.value
                if ( value ) {
                    picker.set( 'highlight', [ value, picker.get( 'view' ).month, picker.get( 'highlight' ).date ] )
                    picker.$root.find( '.' + settings.klass.selectYear ).trigger( 'focus' )
                }
            })
        }, 1 ).
        on( 'open', function() {
            var includeToday = ''
            if ( calendar.disabled( calendar.get('now') ) ) {
                includeToday = ':not(.' + settings.klass.buttonToday + ')'
            }
            picker.$root.find( 'button' + includeToday + ', select' ).attr( 'disabled', false )
        }, 1 ).
        on( 'close', function() {
            picker.$root.find( 'button, select' ).attr( 'disabled', true )
        }, 1 )

} //DatePicker


/**
 * Set a datepicker item object.
 */
DatePicker.prototype.set = function( type, value, options ) {

    var calendar = this,
        calendarItem = calendar.item

    // If the value is `null` just set it immediately.
    if ( value === null ) {
        if ( type == 'clear' ) type = 'select'
        calendarItem[ type ] = value
        return calendar
    }

    // Otherwise go through the queue of methods, and invoke the functions.
    // Update this as the time unit, and set the final value as this item.
    // * In the case of `enable`, keep the queue but set `disable` instead.
    //   And in the case of `flip`, keep the queue but set `enable` instead.
    calendarItem[ ( type == 'enable' ? 'disable' : type == 'flip' ? 'enable' : type ) ] = calendar.queue[ type ].split( ' ' ).map( function( method ) {
        value = calendar[ method ]( type, value, options )
        return value
    }).pop()

    // Check if we need to cascade through more updates.
    if ( type == 'select' ) {
        calendar.set( 'highlight', calendarItem.select, options )
    }
    else if ( type == 'highlight' ) {
        calendar.set( 'view', calendarItem.highlight, options )
    }
    else if ( type.match( /^(flip|min|max|disable|enable)$/ ) ) {
        if ( calendarItem.select && calendar.disabled( calendarItem.select ) ) {
            calendar.set( 'select', calendarItem.select, options )
        }
        if ( calendarItem.highlight && calendar.disabled( calendarItem.highlight ) ) {
            calendar.set( 'highlight', calendarItem.highlight, options )
        }
    }

    return calendar
} //DatePicker.prototype.set


/**
 * Get a datepicker item object.
 */
DatePicker.prototype.get = function( type ) {
    return this.item[ type ]
} //DatePicker.prototype.get


/**
 * Create a picker date object.
 */
DatePicker.prototype.create = function( type, value, options ) {

    var isInfiniteValue,
        calendar = this

    // If there’s no value, use the type as the value.
    value = value === undefined ? type : value


    // If it’s infinity, update the value.
    if ( value == -Infinity || value == Infinity ) {
        isInfiniteValue = value
    }

    // If it’s an object, use the native date object.
    else if ( $.isPlainObject( value ) && _.isInteger( value.pick ) ) {
        value = value.obj
    }

    // If it’s an array, convert it into a date and make sure
    // that it’s a valid date – otherwise default to today.
    else if ( $.isArray( value ) ) {
        value = new Date( value[ 0 ], value[ 1 ], value[ 2 ] )
        value = _.isDate( value ) ? value : calendar.create().obj
    }

    // If it’s a number or date object, make a normalized date.
    else if ( _.isInteger( value ) || _.isDate( value ) ) {
        value = calendar.normalize( new Date( value ), options )
    }

    // If it’s a literal true or any other case, set it to now.
    else /*if ( value === true )*/ {
        value = calendar.now( type, value, options )
    }

    // Return the compiled object.
    return {
        year: isInfiniteValue || value.getFullYear(),
        month: isInfiniteValue || value.getMonth(),
        date: isInfiniteValue || value.getDate(),
        day: isInfiniteValue || value.getDay(),
        obj: isInfiniteValue || value,
        pick: isInfiniteValue || value.getTime()
    }
} //DatePicker.prototype.create


/**
 * Create a range limit object using an array, date object,
 * literal “true”, or integer relative to another time.
 */
DatePicker.prototype.createRange = function( from, to ) {

    var calendar = this,
        createDate = function( date ) {
            if ( date === true || $.isArray( date ) || _.isDate( date ) ) {
                return calendar.create( date )
            }
            return date
        }

    // Create objects if possible.
    if ( !_.isInteger( from ) ) {
        from = createDate( from )
    }
    if ( !_.isInteger( to ) ) {
        to = createDate( to )
    }

    // Create relative dates.
    if ( _.isInteger( from ) && $.isPlainObject( to ) ) {
        from = [ to.year, to.month, to.date + from ];
    }
    else if ( _.isInteger( to ) && $.isPlainObject( from ) ) {
        to = [ from.year, from.month, from.date + to ];
    }

    return {
        from: createDate( from ),
        to: createDate( to )
    }
} //DatePicker.prototype.createRange


/**
 * Check if a date unit falls within a date range object.
 */
DatePicker.prototype.withinRange = function( range, dateUnit ) {
    range = this.createRange(range.from, range.to)
    return dateUnit.pick >= range.from.pick && dateUnit.pick <= range.to.pick
}


/**
 * Check if two date range objects overlap.
 */
DatePicker.prototype.overlapRanges = function( one, two ) {

    var calendar = this

    // Convert the ranges into comparable dates.
    one = calendar.createRange( one.from, one.to )
    two = calendar.createRange( two.from, two.to )

    return calendar.withinRange( one, two.from ) || calendar.withinRange( one, two.to ) ||
        calendar.withinRange( two, one.from ) || calendar.withinRange( two, one.to )
}


/**
 * Get the date today.
 */
DatePicker.prototype.now = function( type, value, options ) {
    value = new Date()
    if ( options && options.rel ) {
        value.setDate( value.getDate() + options.rel )
    }
    return this.normalize( value, options )
}


/**
 * Navigate to next/prev month.
 */
DatePicker.prototype.navigate = function( type, value, options ) {

    var targetDateObject,
        targetYear,
        targetMonth,
        targetDate,
        isTargetArray = $.isArray( value ),
        isTargetObject = $.isPlainObject( value ),
        viewsetObject = this.item.view/*,
        safety = 100*/


    if ( isTargetArray || isTargetObject ) {

        if ( isTargetObject ) {
            targetYear = value.year
            targetMonth = value.month
            targetDate = value.date
        }
        else {
            targetYear = +value[0]
            targetMonth = +value[1]
            targetDate = +value[2]
        }

        // If we’re navigating months but the view is in a different
        // month, navigate to the view’s year and month.
        if ( options && options.nav && viewsetObject && viewsetObject.month !== targetMonth ) {
            targetYear = viewsetObject.year
            targetMonth = viewsetObject.month
        }

        // Figure out the expected target year and month.
        targetDateObject = new Date( targetYear, targetMonth + ( options && options.nav ? options.nav : 0 ), 1 )
        targetYear = targetDateObject.getFullYear()
        targetMonth = targetDateObject.getMonth()

        // If the month we’re going to doesn’t have enough days,
        // keep decreasing the date until we reach the month’s last date.
        while ( /*safety &&*/ new Date( targetYear, targetMonth, targetDate ).getMonth() !== targetMonth ) {
            targetDate -= 1
            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while navigating to ' + new Date( targetYear, targetMonth, targetDate ) + '.'
            }*/
        }

        value = [ targetYear, targetMonth, targetDate ]
    }

    return value
} //DatePicker.prototype.navigate


/**
 * Normalize a date by setting the hours to midnight.
 */
DatePicker.prototype.normalize = function( value/*, options*/ ) {
    value.setHours( 0, 0, 0, 0 )
    return value
}


/**
 * Measure the range of dates.
 */
DatePicker.prototype.measure = function( type, value/*, options*/ ) {

    var calendar = this
    
    // If it's an integer, get a date relative to today.
    if ( _.isInteger( value ) ) {
        value = calendar.now( type, value, { rel: value } )
    }

    // If it’s anything false-y, remove the limits.
    else if ( !value ) {
        value = type == 'min' ? -Infinity : Infinity
    }

    // If it’s a string, parse it.
    else if ( typeof value == 'string' ) {
        value = calendar.parse( type, value )
    }

    return value
} ///DatePicker.prototype.measure


/**
 * Create a viewset object based on navigation.
 */
DatePicker.prototype.viewset = function( type, dateObject/*, options*/ ) {
    return this.create([ dateObject.year, dateObject.month, 1 ])
}


/**
 * Validate a date as enabled and shift if needed.
 */
DatePicker.prototype.validate = function( type, dateObject, options ) {

    var calendar = this,

        // Keep a reference to the original date.
        originalDateObject = dateObject,

        // Make sure we have an interval.
        interval = options && options.interval ? options.interval : 1,

        // Check if the calendar enabled dates are inverted.
        isFlippedBase = calendar.item.enable === -1,

        // Check if we have any enabled dates after/before now.
        hasEnabledBeforeTarget, hasEnabledAfterTarget,

        // The min & max limits.
        minLimitObject = calendar.item.min,
        maxLimitObject = calendar.item.max,

        // Check if we’ve reached the limit during shifting.
        reachedMin, reachedMax,

        // Check if the calendar is inverted and at least one weekday is enabled.
        hasEnabledWeekdays = isFlippedBase && calendar.item.disable.filter( function( value ) {

            // If there’s a date, check where it is relative to the target.
            if ( $.isArray( value ) ) {
                var dateTime = calendar.create( value ).pick
                if ( dateTime < dateObject.pick ) hasEnabledBeforeTarget = true
                else if ( dateTime > dateObject.pick ) hasEnabledAfterTarget = true
            }

            // Return only integers for enabled weekdays.
            return _.isInteger( value )
        }).length/*,

        safety = 100*/



    // Cases to validate for:
    // [1] Not inverted and date disabled.
    // [2] Inverted and some dates enabled.
    // [3] Not inverted and out of range.
    //
    // Cases to **not** validate for:
    // • Navigating months.
    // • Not inverted and date enabled.
    // • Inverted and all dates disabled.
    // • ..and anything else.
    if ( !options || (!options.nav && !options.defaultValue) ) if (
        /* 1 */ ( !isFlippedBase && calendar.disabled( dateObject ) ) ||
        /* 2 */ ( isFlippedBase && calendar.disabled( dateObject ) && ( hasEnabledWeekdays || hasEnabledBeforeTarget || hasEnabledAfterTarget ) ) ||
        /* 3 */ ( !isFlippedBase && (dateObject.pick <= minLimitObject.pick || dateObject.pick >= maxLimitObject.pick) )
    ) {


        // When inverted, flip the direction if there aren’t any enabled weekdays
        // and there are no enabled dates in the direction of the interval.
        if ( isFlippedBase && !hasEnabledWeekdays && ( ( !hasEnabledAfterTarget && interval > 0 ) || ( !hasEnabledBeforeTarget && interval < 0 ) ) ) {
            interval *= -1
        }


        // Keep looping until we reach an enabled date.
        while ( /*safety &&*/ calendar.disabled( dateObject ) ) {

            /*safety -= 1
            if ( !safety ) {
                throw 'Fell into an infinite loop while validating ' + dateObject.obj + '.'
            }*/


            // If we’ve looped into the next/prev month with a large interval, return to the original date and flatten the interval.
            if ( Math.abs( interval ) > 1 && ( dateObject.month < originalDateObject.month || dateObject.month > originalDateObject.month ) ) {
                dateObject = originalDateObject
                interval = interval > 0 ? 1 : -1
            }


            // If we’ve reached the min/max limit, reverse the direction, flatten the interval and set it to the limit.
            if ( dateObject.pick <= minLimitObject.pick ) {
                reachedMin = true
                interval = 1
                dateObject = calendar.create([
                    minLimitObject.year,
                    minLimitObject.month,
                    minLimitObject.date + (dateObject.pick === minLimitObject.pick ? 0 : -1)
                ])
            }
            else if ( dateObject.pick >= maxLimitObject.pick ) {
                reachedMax = true
                interval = -1
                dateObject = calendar.create([
                    maxLimitObject.year,
                    maxLimitObject.month,
                    maxLimitObject.date + (dateObject.pick === maxLimitObject.pick ? 0 : 1)
                ])
            }


            // If we’ve reached both limits, just break out of the loop.
            if ( reachedMin && reachedMax ) {
                break
            }


            // Finally, create the shifted date using the interval and keep looping.
            dateObject = calendar.create([ dateObject.year, dateObject.month, dateObject.date + interval ])
        }

    } //endif


    // Return the date object settled on.
    return dateObject
} //DatePicker.prototype.validate


/**
 * Check if a date is disabled.
 */
DatePicker.prototype.disabled = function( dateToVerify ) {

    var
        calendar = this,

        // Filter through the disabled dates to check if this is one.
        isDisabledMatch = calendar.item.disable.filter( function( dateToDisable ) {

            // If the date is a number, match the weekday with 0index and `firstDay` check.
            if ( _.isInteger( dateToDisable ) ) {
                return dateToVerify.day === ( calendar.settings.firstDay ? dateToDisable : dateToDisable - 1 ) % 7
            }

            // If it’s an array or a native JS date, create and match the exact date.
            if ( $.isArray( dateToDisable ) || _.isDate( dateToDisable ) ) {
                return dateToVerify.pick === calendar.create( dateToDisable ).pick
            }

            // If it’s an object, match a date within the “from” and “to” range.
            if ( $.isPlainObject( dateToDisable ) ) {
                return calendar.withinRange( dateToDisable, dateToVerify )
            }
        })

    // If this date matches a disabled date, confirm it’s not inverted.
    isDisabledMatch = isDisabledMatch.length && !isDisabledMatch.filter(function( dateToDisable ) {
        return $.isArray( dateToDisable ) && dateToDisable[3] == 'inverted' ||
            $.isPlainObject( dateToDisable ) && dateToDisable.inverted
    }).length

    // Check the calendar “enabled” flag and respectively flip the
    // disabled state. Then also check if it’s beyond the min/max limits.
    return calendar.item.enable === -1 ? !isDisabledMatch : isDisabledMatch ||
        dateToVerify.pick < calendar.item.min.pick ||
        dateToVerify.pick > calendar.item.max.pick

} //DatePicker.prototype.disabled


/**
 * Parse a string into a usable type.
 */
DatePicker.prototype.parse = function( type, value, options ) {

    var calendar = this,
        parsingObject = {}

    // If it’s already parsed, we’re good.
    if ( !value || typeof value != 'string' ) {
        return value
    }

    // We need a `.format` to parse the value with.
    if ( !( options && options.format ) ) {
        options = options || {}
        options.format = calendar.settings.format
    }

    // Convert the format into an array and then map through it.
    calendar.formats.toArray( options.format ).map( function( label ) {

        var
            // Grab the formatting label.
            formattingLabel = calendar.formats[ label ],

            // The format length is from the formatting label function or the
            // label length without the escaping exclamation (!) mark.
            formatLength = formattingLabel ? _.trigger( formattingLabel, calendar, [ value, parsingObject ] ) : label.replace( /^!/, '' ).length

        // If there's a format label, split the value up to the format length.
        // Then add it to the parsing object with appropriate label.
        if ( formattingLabel ) {
            parsingObject[ label ] = value.substr( 0, formatLength )
        }

        // Update the value as the substring from format length to end.
        value = value.substr( formatLength )
    })

    // Compensate for month 0index.
    return [
        parsingObject.yyyy || parsingObject.yy,
        +( parsingObject.mm || parsingObject.m ) - 1,
        parsingObject.dd || parsingObject.d
    ]
} //DatePicker.prototype.parse


/**
 * Various formats to display the object in.
 */
DatePicker.prototype.formats = (function() {

    // Return the length of the first word in a collection.
    function getWordLengthFromCollection( string, collection, dateObject ) {

        // Grab the first word from the string.
        // Regex pattern from http://stackoverflow.com/q/150033
        var word = string.match( /[^\x00-\x7F]+|\w+/ )[ 0 ]

        // If there's no month index, add it to the date object
        if ( !dateObject.mm && !dateObject.m ) {
            dateObject.m = collection.indexOf( word ) + 1
        }

        // Return the length of the word.
        return word.length
    }

    // Get the length of the first word in a string.
    function getFirstWordLength( string ) {
        return string.match( /\w+/ )[ 0 ].length
    }

    return {

        d: function( string, dateObject ) {

            // If there's string, then get the digits length.
            // Otherwise return the selected date.
            return string ? _.digits( string ) : dateObject.date
        },
        dd: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected date with a leading zero.
            return string ? 2 : _.lead( dateObject.date )
        },
        ddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the short selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysShort[ dateObject.day ]
        },
        dddd: function( string, dateObject ) {

            // If there's a string, then get the length of the first word.
            // Otherwise return the full selected weekday.
            return string ? getFirstWordLength( string ) : this.settings.weekdaysFull[ dateObject.day ]
        },
        m: function( string, dateObject ) {

            // If there's a string, then get the length of the digits
            // Otherwise return the selected month with 0index compensation.
            return string ? _.digits( string ) : dateObject.month + 1
        },
        mm: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected month with 0index and leading zero.
            return string ? 2 : _.lead( dateObject.month + 1 )
        },
        mmm: function( string, dateObject ) {

            var collection = this.settings.monthsShort

            // If there's a string, get length of the relevant month from the short
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        mmmm: function( string, dateObject ) {

            var collection = this.settings.monthsFull

            // If there's a string, get length of the relevant month from the full
            // months collection. Otherwise return the selected month from that collection.
            return string ? getWordLengthFromCollection( string, collection, dateObject ) : collection[ dateObject.month ]
        },
        yy: function( string, dateObject ) {

            // If there's a string, then the length is always 2.
            // Otherwise return the selected year by slicing out the first 2 digits.
            return string ? 2 : ( '' + dateObject.year ).slice( 2 )
        },
        yyyy: function( string, dateObject ) {

            // If there's a string, then the length is always 4.
            // Otherwise return the selected year.
            return string ? 4 : dateObject.year
        },

        // Create an array by splitting the formatting string passed.
        toArray: function( formatString ) { return formatString.split( /(d{1,4}|m{1,4}|y{4}|yy|!.)/g ) },

        // Format an object into a string using the formatting options.
        toString: function ( formatString, itemObject ) {
            var calendar = this
            return calendar.formats.toArray( formatString ).map( function( label ) {
                return _.trigger( calendar.formats[ label ], calendar, [ 0, itemObject ] ) || label.replace( /^!/, '' )
            }).join( '' )
        }
    }
})() //DatePicker.prototype.formats




/**
 * Check if two date units are the exact.
 */
DatePicker.prototype.isDateExact = function( one, two ) {

    var calendar = this

    // When we’re working with weekdays, do a direct comparison.
    if (
        ( _.isInteger( one ) && _.isInteger( two ) ) ||
        ( typeof one == 'boolean' && typeof two == 'boolean' )
     ) {
        return one === two
    }

    // When we’re working with date representations, compare the “pick” value.
    if (
        ( _.isDate( one ) || $.isArray( one ) ) &&
        ( _.isDate( two ) || $.isArray( two ) )
    ) {
        return calendar.create( one ).pick === calendar.create( two ).pick
    }

    // When we’re working with range objects, compare the “from” and “to”.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.isDateExact( one.from, two.from ) && calendar.isDateExact( one.to, two.to )
    }

    return false
}


/**
 * Check if two date units overlap.
 */
DatePicker.prototype.isDateOverlap = function( one, two ) {

    var calendar = this,
        firstDay = calendar.settings.firstDay ? 1 : 0

    // When we’re working with a weekday index, compare the days.
    if ( _.isInteger( one ) && ( _.isDate( two ) || $.isArray( two ) ) ) {
        one = one % 7 + firstDay
        return one === calendar.create( two ).day + 1
    }
    if ( _.isInteger( two ) && ( _.isDate( one ) || $.isArray( one ) ) ) {
        two = two % 7 + firstDay
        return two === calendar.create( one ).day + 1
    }

    // When we’re working with range objects, check if the ranges overlap.
    if ( $.isPlainObject( one ) && $.isPlainObject( two ) ) {
        return calendar.overlapRanges( one, two )
    }

    return false
}


/**
 * Flip the “enabled” state.
 */
DatePicker.prototype.flipEnable = function(val) {
    var itemObject = this.item
    itemObject.enable = val || (itemObject.enable == -1 ? 1 : -1)
}


/**
 * Mark a collection of dates as “disabled”.
 */
DatePicker.prototype.deactivate = function( type, datesToDisable ) {

    var calendar = this,
        disabledItems = calendar.item.disable.slice(0)


    // If we’re flipping, that’s all we need to do.
    if ( datesToDisable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToDisable === false ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToDisable === true ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the dates to disable.
    else {

        datesToDisable.map(function( unitToDisable ) {

            var matchFound

            // When we have disabled items, check for matches.
            // If something is matched, immediately break out.
            for ( var index = 0; index < disabledItems.length; index += 1 ) {
                if ( calendar.isDateExact( unitToDisable, disabledItems[index] ) ) {
                    matchFound = true
                    break
                }
            }

            // If nothing was found, add the validated unit to the collection.
            if ( !matchFound ) {
                if (
                    _.isInteger( unitToDisable ) ||
                    _.isDate( unitToDisable ) ||
                    $.isArray( unitToDisable ) ||
                    ( $.isPlainObject( unitToDisable ) && unitToDisable.from && unitToDisable.to )
                ) {
                    disabledItems.push( unitToDisable )
                }
            }
        })
    }

    // Return the updated collection.
    return disabledItems
} //DatePicker.prototype.deactivate


/**
 * Mark a collection of dates as “enabled”.
 */
DatePicker.prototype.activate = function( type, datesToEnable ) {

    var calendar = this,
        disabledItems = calendar.item.disable,
        disabledItemsCount = disabledItems.length

    // If we’re flipping, that’s all we need to do.
    if ( datesToEnable == 'flip' ) {
        calendar.flipEnable()
    }

    else if ( datesToEnable === true ) {
        calendar.flipEnable(1)
        disabledItems = []
    }

    else if ( datesToEnable === false ) {
        calendar.flipEnable(-1)
        disabledItems = []
    }

    // Otherwise go through the disabled dates.
    else {

        datesToEnable.map(function( unitToEnable ) {

            var matchFound,
                disabledUnit,
                index,
                isExactRange

            // Go through the disabled items and try to find a match.
            for ( index = 0; index < disabledItemsCount; index += 1 ) {

                disabledUnit = disabledItems[index]

                // When an exact match is found, remove it from the collection.
                if ( calendar.isDateExact( disabledUnit, unitToEnable ) ) {
                    matchFound = disabledItems[index] = null
                    isExactRange = true
                    break
                }

                // When an overlapped match is found, add the “inverted” state to it.
                else if ( calendar.isDateOverlap( disabledUnit, unitToEnable ) ) {
                    if ( $.isPlainObject( unitToEnable ) ) {
                        unitToEnable.inverted = true
                        matchFound = unitToEnable
                    }
                    else if ( $.isArray( unitToEnable ) ) {
                        matchFound = unitToEnable
                        if ( !matchFound[3] ) matchFound.push( 'inverted' )
                    }
                    else if ( _.isDate( unitToEnable ) ) {
                        matchFound = [ unitToEnable.getFullYear(), unitToEnable.getMonth(), unitToEnable.getDate(), 'inverted' ]
                    }
                    break
                }
            }

            // If a match was found, remove a previous duplicate entry.
            if ( matchFound ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateExact( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // In the event that we’re dealing with an exact range of dates,
            // make sure there are no “inverted” dates because of it.
            if ( isExactRange ) for ( index = 0; index < disabledItemsCount; index += 1 ) {
                if ( calendar.isDateOverlap( disabledItems[index], unitToEnable ) ) {
                    disabledItems[index] = null
                    break
                }
            }

            // If something is still matched, add it into the collection.
            if ( matchFound ) {
                disabledItems.push( matchFound )
            }
        })
    }

    // Return the updated collection.
    return disabledItems.filter(function( val ) { return val != null })
} //DatePicker.prototype.activate


/**
 * Create a string for the nodes in the picker.
 */
DatePicker.prototype.nodes = function( isOpen ) {

    var
        calendar = this,
        settings = calendar.settings,
        calendarItem = calendar.item,
        nowObject = calendarItem.now,
        selectedObject = calendarItem.select,
        highlightedObject = calendarItem.highlight,
        viewsetObject = calendarItem.view,
        disabledCollection = calendarItem.disable,
        minLimitObject = calendarItem.min,
        maxLimitObject = calendarItem.max,


        // Create the calendar table head using a copy of weekday labels collection.
        // * We do a copy so we don't mutate the original array.
        tableHead = (function( collection, fullCollection ) {

            // If the first day should be Monday, move Sunday to the end.
            if ( settings.firstDay ) {
                collection.push( collection.shift() )
                fullCollection.push( fullCollection.shift() )
            }

            // Create and return the table head group.
            return _.node(
                'thead',
                _.node(
                    'tr',
                    _.group({
                        min: 0,
                        max: DAYS_IN_WEEK - 1,
                        i: 1,
                        node: 'th',
                        item: function( counter ) {
                            return [
                                collection[ counter ],
                                settings.klass.weekdays,
                                'scope=col title="' + fullCollection[ counter ] + '"'
                            ]
                        }
                    })
                )
            ) //endreturn
        })( ( settings.showWeekdaysFull ? settings.weekdaysFull : settings.weekdaysShort ).slice( 0 ), settings.weekdaysFull.slice( 0 ) ), //tableHead


        // Create the nav for next/prev month.
        createMonthNav = function( next ) {

            // Otherwise, return the created month tag.
            return _.node(
                'div',
                ' ',
                settings.klass[ 'nav' + ( next ? 'Next' : 'Prev' ) ] + (

                    // If the focused month is outside the range, disabled the button.
                    ( next && viewsetObject.year >= maxLimitObject.year && viewsetObject.month >= maxLimitObject.month ) ||
                    ( !next && viewsetObject.year <= minLimitObject.year && viewsetObject.month <= minLimitObject.month ) ?
                    ' ' + settings.klass.navDisabled : ''
                ),
                'data-nav=' + ( next || -1 ) + ' ' +
                _.ariaAttr({
                    role: 'button',
                    controls: calendar.$node[0].id + '_table'
                }) + ' ' +
                'title="' + (next ? settings.labelMonthNext : settings.labelMonthPrev ) + '"'
            ) //endreturn
        }, //createMonthNav


        // Create the month label.
        createMonthLabel = function() {

            var monthsCollection = settings.showMonthsShort ? settings.monthsShort : settings.monthsFull

            // If there are months to select, add a dropdown menu.
            if ( settings.selectMonths ) {

                return _.node( 'select',
                    _.group({
                        min: 0,
                        max: 11,
                        i: 1,
                        node: 'option',
                        item: function( loopedMonth ) {

                            return [

                                // The looped month and no classes.
                                monthsCollection[ loopedMonth ], 0,

                                // Set the value and selected index.
                                'value=' + loopedMonth +
                                ( viewsetObject.month == loopedMonth ? ' selected' : '' ) +
                                (
                                    (
                                        ( viewsetObject.year == minLimitObject.year && loopedMonth < minLimitObject.month ) ||
                                        ( viewsetObject.year == maxLimitObject.year && loopedMonth > maxLimitObject.month )
                                    ) ?
                                    ' disabled' : ''
                                )
                            ]
                        }
                    }),
                    settings.klass.selectMonth,
                    ( isOpen ? '' : 'disabled' ) + ' ' +
                    _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelMonthSelect + '"'
                )
            }

            // If there's a need for a month selector
            return _.node( 'div', monthsCollection[ viewsetObject.month ], settings.klass.month )
        }, //createMonthLabel


        // Create the year label.
        createYearLabel = function() {

            var focusedYear = viewsetObject.year,

            // If years selector is set to a literal "true", set it to 5. Otherwise
            // divide in half to get half before and half after focused year.
            numberYears = settings.selectYears === true ? 5 : ~~( settings.selectYears / 2 )

            // If there are years to select, add a dropdown menu.
            if ( numberYears ) {

                var
                    minYear = minLimitObject.year,
                    maxYear = maxLimitObject.year,
                    lowestYear = focusedYear - numberYears,
                    highestYear = focusedYear + numberYears

                // If the min year is greater than the lowest year, increase the highest year
                // by the difference and set the lowest year to the min year.
                if ( minYear > lowestYear ) {
                    highestYear += minYear - lowestYear
                    lowestYear = minYear
                }

                // If the max year is less than the highest year, decrease the lowest year
                // by the lower of the two: available and needed years. Then set the
                // highest year to the max year.
                if ( maxYear < highestYear ) {

                    var availableYears = lowestYear - minYear,
                        neededYears = highestYear - maxYear

                    lowestYear -= availableYears > neededYears ? neededYears : availableYears
                    highestYear = maxYear
                }

                return _.node( 'select',
                    _.group({
                        min: lowestYear,
                        max: highestYear,
                        i: 1,
                        node: 'option',
                        item: function( loopedYear ) {
                            return [

                                // The looped year and no classes.
                                loopedYear, 0,

                                // Set the value and selected index.
                                'value=' + loopedYear + ( focusedYear == loopedYear ? ' selected' : '' )
                            ]
                        }
                    }),
                    settings.klass.selectYear,
                    ( isOpen ? '' : 'disabled' ) + ' ' + _.ariaAttr({ controls: calendar.$node[0].id + '_table' }) + ' ' +
                    'title="' + settings.labelYearSelect + '"'
                )
            }

            // Otherwise just return the year focused
            return _.node( 'div', focusedYear, settings.klass.year )
        } //createYearLabel


    // Create and return the entire calendar.
    return _.node(
        'div',
        ( settings.selectYears ? createYearLabel() + createMonthLabel() : createMonthLabel() + createYearLabel() ) +
        createMonthNav() + createMonthNav( 1 ),
        settings.klass.header
    ) + _.node(
        'table',
        tableHead +
        _.node(
            'tbody',
            _.group({
                min: 0,
                max: WEEKS_IN_CALENDAR - 1,
                i: 1,
                node: 'tr',
                item: function( rowCounter ) {

                    // If Monday is the first day and the month starts on Sunday, shift the date back a week.
                    var shiftDateBy = settings.firstDay && calendar.create([ viewsetObject.year, viewsetObject.month, 1 ]).day === 0 ? -7 : 0

                    return [
                        _.group({
                            min: DAYS_IN_WEEK * rowCounter - viewsetObject.day + shiftDateBy + 1, // Add 1 for weekday 0index
                            max: function() {
                                return this.min + DAYS_IN_WEEK - 1
                            },
                            i: 1,
                            node: 'td',
                            item: function( targetDate ) {

                                // Convert the time date from a relative date to a target date.
                                targetDate = calendar.create([ viewsetObject.year, viewsetObject.month, targetDate + ( settings.firstDay ? 1 : 0 ) ])

                                var isSelected = selectedObject && selectedObject.pick == targetDate.pick,
                                    isHighlighted = highlightedObject && highlightedObject.pick == targetDate.pick,
                                    isDisabled = disabledCollection && calendar.disabled( targetDate ) || targetDate.pick < minLimitObject.pick || targetDate.pick > maxLimitObject.pick,
                                    formattedDate = _.trigger( calendar.formats.toString, calendar, [ settings.format, targetDate ] )

                                return [
                                    _.node(
                                        'div',
                                        targetDate.date,
                                        (function( klasses ) {

                                            // Add the `infocus` or `outfocus` classes based on month in view.
                                            klasses.push( viewsetObject.month == targetDate.month ? settings.klass.infocus : settings.klass.outfocus )

                                            // Add the `today` class if needed.
                                            if ( nowObject.pick == targetDate.pick ) {
                                                klasses.push( settings.klass.now )
                                            }

                                            // Add the `selected` class if something's selected and the time matches.
                                            if ( isSelected ) {
                                                klasses.push( settings.klass.selected )
                                            }

                                            // Add the `highlighted` class if something's highlighted and the time matches.
                                            if ( isHighlighted ) {
                                                klasses.push( settings.klass.highlighted )
                                            }

                                            // Add the `disabled` class if something's disabled and the object matches.
                                            if ( isDisabled ) {
                                                klasses.push( settings.klass.disabled )
                                            }

                                            return klasses.join( ' ' )
                                        })([ settings.klass.day ]),
                                        'data-pick=' + targetDate.pick + ' ' + _.ariaAttr({
                                            role: 'gridcell',
                                            label: formattedDate,
                                            selected: isSelected && calendar.$node.val() === formattedDate ? true : null,
                                            activedescendant: isHighlighted ? true : null,
                                            disabled: isDisabled ? true : null
                                        })
                                    ),
                                    '',
                                    _.ariaAttr({ role: 'presentation' })
                                ] //endreturn
                            }
                        })
                    ] //endreturn
                }
            })
        ),
        settings.klass.table,
        'id="' + calendar.$node[0].id + '_table' + '" ' + _.ariaAttr({
            role: 'grid',
            controls: calendar.$node[0].id,
            readonly: true
        })
    ) +

    // * For Firefox forms to submit, make sure to set the buttons’ `type` attributes as “button”.
    _.node(
        'div',
        _.node( 'button', settings.today, settings.klass.buttonToday,
            'type=button data-pick=' + nowObject.pick +
            ( isOpen && !calendar.disabled(nowObject) ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ) +
        _.node( 'button', settings.clear, settings.klass.buttonClear,
            'type=button data-clear=1' +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ) +
        _.node('button', settings.close, settings.klass.buttonClose,
            'type=button data-close=true ' +
            ( isOpen ? '' : ' disabled' ) + ' ' +
            _.ariaAttr({ controls: calendar.$node[0].id }) ),
        settings.klass.footer
    ) //endreturn
} //DatePicker.prototype.nodes




/**
 * The date picker defaults.
 */
DatePicker.defaults = (function( prefix ) {

    return {

        // The title label to use for the month nav buttons
        labelMonthNext: 'Next month',
        labelMonthPrev: 'Previous month',

        // The title label to use for the dropdown selectors
        labelMonthSelect: 'Select a month',
        labelYearSelect: 'Select a year',

        // Months and weekdays
        monthsFull: [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ],
        monthsShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
        weekdaysFull: [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ],
        weekdaysShort: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ],

        // Today and clear
        today: 'Today',
        clear: 'Clear',
        close: 'Close',

        // Picker close behavior
        closeOnSelect: true,
        closeOnClear: true,

        // Update input value on select/clear
        updateInput: true,

        // The format to show on the `input` element
        format: 'd mmmm, yyyy',

        // Classes
        klass: {

            table: prefix + 'table',

            header: prefix + 'header',

            navPrev: prefix + 'nav--prev',
            navNext: prefix + 'nav--next',
            navDisabled: prefix + 'nav--disabled',

            month: prefix + 'month',
            year: prefix + 'year',

            selectMonth: prefix + 'select--month',
            selectYear: prefix + 'select--year',

            weekdays: prefix + 'weekday',

            day: prefix + 'day',
            disabled: prefix + 'day--disabled',
            selected: prefix + 'day--selected',
            highlighted: prefix + 'day--highlighted',
            now: prefix + 'day--today',
            infocus: prefix + 'day--infocus',
            outfocus: prefix + 'day--outfocus',

            footer: prefix + 'footer',

            buttonClear: prefix + 'button--clear',
            buttonToday: prefix + 'button--today',
            buttonClose: prefix + 'button--close'
        }
    }
})( Picker.klasses().picker + '__' )





/**
 * Extend the picker to add the date picker.
 */
Picker.extend( 'pickadate', DatePicker )


}));






(function ($, config) {
    /**
     * Replace any root-relative href attributes with the full URL
     *
     * PDFmyURL needs to be able to load resources (specifically CSS/JS) from the HTML we send.
     * If the hrefs are root-relative, it won't resolve them
     */
    function makeHrefsFullUrls(doc) {
        $(doc).find('[href]').not('[href^="http"],[href^="https"],[href^="mailto:"],[href^="#"]').each(function (index, element) {
            $(this).attr('href', function (index, value) {
                if (value.substr(0, 1) !== "/") {
                    value = window.location.pathname + value;
                }

                return element.href + value;
            });
        });
    }

    /**
     * Sends the content of a page to PDFmyURL
     *
     * We need this for pages that are behind a login or dynmically generated (eg. order confirmation)
     *
     * @param key {string}
     * @constructor
     */
    function pdfMyUrl(key) {
        // Clone the document so we can edit it without causing reflow and unnnecessary downoads
        var doc = document.documentElement.cloneNode(true);
        makeHrefsFullUrls(doc);

        // Get the document HTML
        var html = doc.outerHTML;

        var data = {
            html: html,
            license: key,
            css_media_type: 'print',
            page_size: 'A4',
            orientation: 'portrait',
            top: 15,
            bottom: 15,
            left: 10,
            right: 10
        };

        // Build post data
        var serialized = Object.keys(data).map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        }).join('&')

        xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            var a;
            if (xhttp.readyState === 4 && xhttp.status === 200) {
                a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhttp.response);
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
            }
        };

        // Send to PDFmyURL
        xhttp.open("POST", "https://pdfmyurl.com/api", true);
        xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhttp.responseType = 'blob';
        xhttp.send(serialized);
    }

    $('.js-pdf-my-url').on('click', function (event) {
        if ('undefined' !== typeof config.key) {
            event.preventDefault();
            pdfMyUrl(config.key);
        }
    });
})(jQuery, window.PDFmyUrlConfig = window.PDFmyUrlConfig || {});

(function ($) {
    function Revealable(element, position, minWidth, alwaysShownWidth) {
        this.element = element;
        this.position = position;
        this.minWidth = minWidth;
        this.alwaysShownWidth = alwaysShownWidth; // At which screen width should it always display, if any
    }

    function ScrollReveal() {
        /**
         * @type {Revealable[]}
         */
        this.revealables = [];
    }

    ScrollReveal.prototype.add = function (revealable) {
        this.revealables.push(revealable);
    };

    ScrollReveal.prototype.update = function (scrollTop) {
        this.revealables.forEach(
            /**
             * @param {Revealable} revealable
             */
            function (revealable) {
                var isMinWidth = !revealable.minWidth || window.matchMedia('(min-width: ' + revealable.minWidth + ')').matches;
                var isAlwaysShownWidth = !revealable.alwaysShownWidth || window.matchMedia('(min-width: ' + revealable.alwaysShownWidth + ')').matches;
                if ((scrollTop > revealable.position && isMinWidth) || isAlwaysShownWidth) {
                    revealable.element.classList.add('scroll-reveal--revealed-start');
                    revealable.element.classList.add('scroll-reveal--revealed');
                } else {
                    revealable.element.classList.remove('scroll-reveal--revealed');
                }
            }
        )
    };

    var manager = new ScrollReveal();

    document.querySelectorAll('.scroll-reveal').forEach(function (element) {
        manager.add(
            new Revealable(
                element,
                Number(element.getAttribute('data-scroll-reveal-position')),
                element.getAttribute('data-scroll-reveal-min-width'),
                element.getAttribute('data-scroll-reveal-always-shown-width')
            )
        );
    });

    manager.update($(window).scrollTop());
    $(window).on('scroll resize orientationchange', debounce(function() {
        manager.update($(window).scrollTop());
    }, 200));
})(jQuery);

var TRIPSMITHS = TRIPSMITHS || {};

TRIPSMITHS.Tracking = {

    trackEvent: function (category, action, label, value, callback) {
        if (value === undefined) {
            value = 0;
        }
        if (callback === undefined) {
            callback = function () {};
        }

        if (window.dataLayer) {
            var timeoutId;
            var gtmCallback = callback;

            if (window.google_tag_manager) {
                gtmCallback = function() {
                    clearTimeout(timeoutId);
                    callback();
                };
                // If GTM gets in a real mess, step in.
                timeoutId = setTimeout(gtmCallback, 2500);
            }

            // Let GTM handle the redirect once it's done its thing.
            dataLayer.push({
                'event': 'd3r.event',
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': value,
                'eventCallback': gtmCallback,
                'eventTimeout': 2000
            });
        }
    }
}

if (typeof SVG_DEFAULT_PATH == "undefined") {
    var SVG_DEFAULT_PATH = '/images/svg-symbols.svg';
}
if (typeof SVG_DEFAULT_PREFIX == "undefined") {
    var SVG_DEFAULT_PREFIX = 'icon';
}
function Svg() {

    this.imagePath = SVG_DEFAULT_PATH;

    this.imageClassPrefix = SVG_DEFAULT_PREFIX;

    this.setImagePath = function(path) {
        if (path) {
            this.imagePath = path;
        }
    }

    this.setImageClassPrefix = function(prefix) {
        if (prefix) {
            this.imageClassPrefix = prefix;
        }
    }

    this.render = function(icon) {
        return '<svg role="img" class="' + this.imageClassPrefix + '-' + this.prepare(icon) + '">' +
                        '<use xlink:href="' + this.imagePath + '#icon-' + this.prepare(icon) + '"></use>' +
                    '</svg>'
    }

    this.prepare = function(icon) {
        return icon.replace('icon-', '');
    }
}


var svg = new Svg();

TRIPSMITHS.QuantityControl = function(options) {

    var self = this;

    this.options = {
        buttonContent: {
            up: svg.render('plus'),
            down: svg.render('minus')
        },
        buttonLabels: {
            up: 'Add',
            down: 'Remove'
        },
        allowed: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57] // 0-9
    };

    $.extend(this.options, options);

    this.init = function() {
        this.options.el.classList.add('quantity-control');
        this.options.el.classList.add('quantity-control--' + this.options.mode);
        this.buttons = {};
        this.input = this.options.el.querySelector('input');
        this.label = this.options.el.querySelector('label');

        if (!this.input.getAttribute('quantity-control-active')) {
            this.updateInput();
            this.addButtons();
            this.watchButtons();
            this.watchInput();
            this.updateButtons();
        }
    }

    this.updateButtons = function() {
        if (this.input.hasAttribute('min')) {
            if (this.input.value == parseInt(this.input.min)) {
                this.buttons.down.setAttribute('disabled', 'true');
            } else {
                this.buttons.down.removeAttribute('disabled');
            }
        }

        if (this.input.hasAttribute('max')) {
            if (this.input.value == parseInt(this.input.max)) {
                this.buttons.up.setAttribute('disabled', 'true');
            } else {
                this.buttons.up.removeAttribute('disabled');
            }
        }
    }

    this.updateInput = function() {
        this.input.type = 'text';
        this.input.id = this.input.id || this.options.id;
        this.input.setAttribute('quantity-control-active', true);
        this.input.setAttribute('aria-live', 'assertive');
        this.label.setAttribute('for', this.input.id);

        if (self.options.max) {
            this.input.max = self.options.max;
        }

        if (self.options.min) {
            this.input.min = self.options.min;
        }
    }

    this.addButtons = function() {
        this.addButton('up');
        this.addButton('down');
    }

    this.addButton = function(button) {
        this.buttons[button] = document.createElement('button');
        this.buttons[button].type = 'button';
        this.buttons[button].classList.add('quantity-control__button');
        this.buttons[button].classList.add('quantity-control__button--' + button);
        this.buttons[button].innerHTML = this.options.buttonContent[button];
        this.buttons[button].setAttribute('aria-label', this.options.buttonLabels[button]);
        this.buttons[button].setAttribute('aria-controls', this.input.id);

        if (button == 'down') {
            this.options.el.insertBefore(this.buttons[button], this.input);
        } else {
            this.options.el.appendChild(this.buttons[button]);
        }
    }

    this.watchButtons = function() {
        this.buttons.up.onclick = function() {
            var max;

            if (self.input.hasAttribute('max')) {
                max = parseInt(self.input.max);
            }

            if ((max != undefined && self.input.value < max) || max == undefined) {
                self.input.value++;
            }

            self.input.dispatchEvent(new Event('change'));
        }

        this.buttons.down.onclick = function() {
            var min = 0;

            if (self.input.hasAttribute('min')) {
                min = parseInt(self.input.min);
            }

            if (self.input.value > min) {
                self.input.value--;
            }

            self.input.dispatchEvent(new Event('change'));
        }
    }

    this.watchInput = function() {
        this.input.onfocus = function() {
            self.input.onkeypress = function(e) {
                // If the key is not in the array of allowed keys, then prevent it
                if (self.options.allowed.indexOf(e.charCode) == -1) {
                    e.preventDefault();
                }
            }
        }

        this.input.onchange = function(e) {
            // If value is not a number, set it to the minimum value
            if (isNaN(parseInt(self.input.value))) {
                if (self.input.hasAttribute('min')) {
                    self.input.value = self.input.min;
                } else {
                    self.input.value = 0;
                }
            }

            if (self.input.hasAttribute('min')) {
                if (parseInt(self.input.value) < parseInt(self.input.min)) {
                    self.input.value = self.input.min;
                    self.input.dispatchEvent(new Event('change'));
                }
            }

            if (self.input.hasAttribute('max')) {
                if (parseInt(self.input.value) > parseInt(self.input.max)) {
                    self.input.value = self.input.max;
                    self.input.dispatchEvent(new Event('change'));
                }
            }

            self.updateButtons();
        }
    }
}


var accommodationPicker = {
    validBooking: false,
    decimalSeparator: '.',
    thousandsSeparator: ',',
    minimumTwoOccupants: false,

    /**
     * Initialise picker.
     */
    init: function() {
        accommodationPicker.setListeners();
        accommodationPicker.initModals();
        accommodationPicker.initDatePicker();
        accommodationPicker.minimumTwoOccupants = $('.accommodation-picker').attr('data-min-two-occupants') == 'true';
    },

    pluraliseLabel: function($label, count) {
        if (count == 1) {
            $label.html($label.attr('data-label-singular'))
        } else {
            $label.html($label.attr('data-label-plural'))
        }
    },

    formatPrice: function(currency, value) {
        value = parseFloat(value).toFixed(2);

        var priceFormatted = '00.00';
        if (value > 0) {
            // Split the decimal part
            var parts = value.toString().split('.');
            var whole = parts[0];
            var decimal = parts[1];

            // Reverse string to add separator
            var reverse = whole.split('').reverse().join('');

            // Add after every 3 digits
            var reverseFormatted = reverse.replace(/(\d{3})/g, "$1" + accommodationPicker.thousandsSeparator);

            // Remove stray separator
            if (reverseFormatted[reverseFormatted.length - 1] === accommodationPicker.thousandsSeparator) {
                reverseFormatted = reverseFormatted.substr(0, reverseFormatted.length - 1);
            }

            // Reverse string back to original
            var wholeFormatted = reverseFormatted.split('').reverse().join('');

            priceFormatted = wholeFormatted + accommodationPicker.decimalSeparator + decimal;
        }

        return currency + priceFormatted;
    },

    /**
     * Update side bar tour total.
     */
    onChoiceChange: function(event) {
        var total = 0.00,
            totalDeposit = 0.00,
            $total = $('.js-sidebar-total-cost'),
            $deposit = $('.js-sidebar-total-deposit'),
            currency = $total.data('currency'),
            triggerMinimumOccupantsPopup = false,
            hasSingleOccupancy = false,
            triggerElem = event.target;

        $('.js-accomm-room', '.accommodation-date-rooms__selected').each(function() {
            var $this = $(this);

            var roomCount = $('.js-accomm-rooms', $this).val();
            if (isNaN(parseInt(roomCount)))
                return;

            var bookingPrice = parseFloat($this.data('price')),
                roomSOS = parseFloat($this.data('sos')),
                bookingType = $this.data('type'),
                $occupants = $('.js-accomm-room-occupants', $this),
                $occupantsLabels = $('.js-room-occupants-label', $this),
                $prices = $('.js-accomm-room-price', $this),
                totalOccupantsForRoom = 0,
                thisTotal = 0,
                depositType = $this.attr('data-deposit-type'),
                depositFixedAmount = $this.attr('data-deposit-fixed-amount'),
                depositPercent = $this.attr('data-deposit-percent'),
                depositPerPerson = $this.attr('data-deposit-per-person'),
                roomHasSingleOccupancy = false;

            switch (bookingType) {
                case 'person':
                    for (var r = 0; r < roomCount; ++r) {
                        var occupants = parseInt($($occupants[r]).val());
                        var roomPrice = occupants * bookingPrice;
                        if (occupants == 1 && roomSOS > 0.0) {
                            roomPrice += roomSOS;
                        }
                        $($prices[r]).text(accommodationPicker.formatPrice(currency, roomPrice));
                        totalOccupantsForRoom += occupants;
                        thisTotal += roomPrice;

                        accommodationPicker.pluraliseLabel($($occupantsLabels[r]), occupants);

                        roomHasSingleOccupancy = roomHasSingleOccupancy || (occupants == 1);

                        if (occupants == 1 && triggerElem == $occupants[r]) {
                            triggerMinimumOccupantsPopup = true;
                        }
                    }

                    break;

                case 'room':
                default:
                    for (var r = 0; r < roomCount; ++r) {
                        var occupants = parseInt($($occupants[r]).val());
                        if (occupants == 0)
                            continue;

                        var roomPrice = bookingPrice;
                        if (occupants == 1 && roomSOS > 0.0) {
                            roomPrice += roomSOS;
                        }
                        $($prices[r]).text(accommodationPicker.formatPrice(currency, roomPrice));
                        totalOccupantsForRoom += occupants;
                        thisTotal += roomPrice;

                        accommodationPicker.pluraliseLabel($($occupantsLabels[r]), occupants);

                        roomHasSingleOccupancy = roomHasSingleOccupancy || (occupants == 1);

                        if (occupants == 1 && triggerElem == $occupants[r]) {
                            triggerMinimumOccupantsPopup = true;
                        }
                    }
                    break;
            }

            switch (depositType) {
                case 'fixed':
                    totalDeposit += depositFixedAmount;
                    break;
                case 'percent':
                    totalDeposit += (depositPercent / 100) * thisTotal;
                    break;
                case 'perperson':
                    totalDeposit += depositPerPerson * totalOccupantsForRoom;
            }

            total += thisTotal;

            $this.find('.accommodation-picker__occupants-error-message').toggleClass('d3r-hidden', !roomHasSingleOccupancy);

            accommodationPicker.pluraliseLabel($this.find('.js-room-input-label'), roomCount);

            hasSingleOccupancy = hasSingleOccupancy || roomHasSingleOccupancy;
        });

        $total.each(function() {
            $(this).text(accommodationPicker.formatPrice(currency, total));
        });

        $deposit.each(function() {
            $(this).text(accommodationPicker.formatPrice(currency, totalDeposit));
        });

        accommodationPicker.validBooking = total > 0 && (!accommodationPicker.minimumTwoOccupants || !hasSingleOccupancy);

        if (triggerMinimumOccupantsPopup && accommodationPicker.minimumTwoOccupants) {
            $.magnificPopup.open({
                items: {
                    src: '.minimum-occupants-popup',
                    type: 'inline',
                },
                closeOnContentClick: false,
                mainClass: "mfp--slim-v2",
            });
        }

        $('button[type="submit"]', '.js-availability-form').attr('disabled', !accommodationPicker.validBooking);
    },

    /**
     * Select a tour date.
     *  - Clear other date room options.
     */
    selectDate: function() {
        var wasID = $('.availability .availability__row--selected .js-date-select').data('dateid'),
            nowID = $(this).data('dateid');

        $('.js-availability-form .js-availability-selected_date').val(nowID);

        if (wasID == nowID) {
            $('.accommodation-date-rooms[data-dateid="' + nowID + '"]').addClass('accommodation-date-rooms__selected');

            $('.availability').hide();
            $('.sidebar__row--active').removeClass('sidebar__row--active');
            $('.accommodation-picker').show();
            $('.sidebar__row--tab[data-tab="cabin"]').each(function() {
                $(this).addClass('sidebar__row--active');
            });
            return;
        }

        $('.js-accom-date-empty').addClass('accommodation-date-empty__hide');

        $('.availability .availability__row--selected .js-date-select span').text('Select');
        $('.availability .availability__row--selected').removeClass('availability__row--selected');

        $('.accommodation-date-rooms').removeClass('accommodation-date-rooms__selected');

        accommodationPicker.resetRooms();

        $('span', this).text('Selected');

        var $row = $(this).closest('.availability__row');
        $('.sidebar__row--tab[data-tab="date"] .sidebar__intro').each(function() {
            $(this).text($row.data('tabdate'));
        });
        $row.addClass('availability__row--selected');

        $('.accommodation-date-rooms[data-dateid="' + nowID + '"]').addClass('accommodation-date-rooms__selected');

        $('.availability').hide();
        $('.sidebar__row--active').each(function() {
            $(this).removeClass('sidebar__row--active');
        });
        $('.accommodation-picker').show();
        $('.sidebar__row--tab[data-tab="cabin"]').each(function() {
            $(this).addClass('sidebar__row--active');
        });
    },

    /**
     * Select Room Count Event.
     *  - Show count of rooms to configure.
     *  - Reset hidden rooms.
     */
    selectRoomCount: function() {
        var roomCount = $(this).val(),
            $group    = $(this).closest('.accommodation-picker__row'),
            $subGroup = $('.accommodation-picker__sub-group', $group),
            $rows     = $('.accommodation-picker__row', $subGroup);

        var showSubGroup = roomCount > 0 ? true : false;

        $subGroup.toggleClass('accommodation-picker__sub-group--open', showSubGroup);

        for (var r = 0; r < roomCount; ++r) {
            $($rows[r]).addClass('accommodation-picker__row--open');
        }

        // Reset the hidden rows to defaults.
        var maxRooms = $group.data('availablerooms');
        for (var r = roomCount; r < maxRooms; ++r) {
            $($rows[r]).removeClass('accommodation-picker__row--open');
            $('.js-accomm-room-type option', $rows[r]).first().prop('selected', true).trigger('change');
            $('.js-accomm-room-occupants option', $rows[r]).first().prop('selected', true).trigger('change');
        }
    },

    /**
     * Reset the room options to defaults across all dates.
     */
    resetRooms: function() {
        $('.js-accomm-date-rooms select').each(function() {
            $('option', $(this)).first().prop('selected', true).trigger('change');
        });
    },

    /**
     * Set event handler listeners.
     */
    setListeners: function() {
        // Sidebar Tabs
        $('.sidebar__row--tab[data-tab="date"]').on('click', function() {
            $('.availability').show();
            $('.sidebar__row--active').each(function() {
                $(this).removeClass('sidebar__row--active');
            });
            $('.accommodation-picker').hide();
            $('.sidebar__row--tab[data-tab="date"]').each(function() {
                $(this).addClass('sidebar__row--active');
            });
        });
        $('.sidebar__row--tab[data-tab="cabin"]').on('click', function() {
            $('.availability').hide();
            $('.sidebar__row--active').each(function() {
                $(this).removeClass('sidebar__row--active');
            });
            $('.accommodation-picker').show();
            $('.sidebar__row--tab[data-tab="cabin"]').each(function() {
                $(this).addClass('sidebar__row--active');
            });
        });

        // Submit form sanity check
        $('.js-availability-form').on('submit', function() {
            return accommodationPicker.validBooking;
        });

        // Date Selection
        $('.js-date-select').on('click', function(event) {
            accommodationPicker.selectDate.call(this);
            accommodationPicker.onChoiceChange.call(this, event);
            return false;
        });

        // Room Count Selection
        $('.js-accomm-room-count input').on('change', function() {
            accommodationPicker.selectRoomCount.call(this);
        });

        // Room Options
        $('.js-accomm-rooms').on('change', function(event) {
            accommodationPicker.onChoiceChange.call(this, event);
        });
        $('.js-accomm-room-occupants').on('change', function(event) {
            accommodationPicker.onChoiceChange.call(this, event);
        });
    },

    initDatePicker: function() {
        if (typeof offer !== 'undefined') {
            if (window.Picker) {
                var options = {
                    format: 'ddd, d mmmm',
                    formatSubmit: 'yyyy/mm/dd',
                    firstDay: 1,
                    clear: false,
                    today: '<span>Today</span>',
                    close: '<span>Close</span>',
                    min: offer.availability.from,
                    max: offer.availability.to,
                    onClose: function () {
                        var selectedDate = new Date(this.get('select').pick);
                        var altPicker;

                        if (this.$root.attr('id') == 'select-date-from_root') {
                            selectedDate = selectedDate.addDays(offer.durationInDays - 1);
                            altPicker = $('#select-date-to').pickadate('picker');
                        } else {
                            selectedDate = selectedDate.removeDays(offer.durationInDays - 1);
                            altPicker = $('#select-date-from').pickadate('picker');
                        }

                        altPicker.set('select', selectedDate);
                    }
                };

                var fromOptions = Object.assign({}, options);
                var toOptions = Object.assign({}, options);

                fromOptions['container'] = '#select-date-from__calendar';
                toOptions['container'] = '#select-date-to__calendar';

                fromOptions.max = fromOptions.max.removeDays(offer.durationInDays - 1);
                toOptions.min = toOptions.min.addDays(offer.durationInDays - 1);

                $('.js__datepicker-from').pickadate(fromOptions);
                $('.js__datepicker-to').pickadate(toOptions);
            }
        }
    },

    /**
     * Init Modals.
     */
    initModals: function() {
        $('.accom-modal').magnificPopup({
            type: 'ajax',
            closeBtnInside: true,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>Close</span></button>',
            closeOnContentClick: false,
            ajax: {
                settings: null,
                cursor: 'mfp-ajax-cur',
                tError: '<a href="%url%">The content</a> could not be loaded.'
            },
            callbacks: {
                ajaxContentAdded: function() {
                    $('.gallery--accommodation-modal').slick({
                        arrows: false,
                        dots: false
                    });

                    $('.gallery--accommodation-modal-nav').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        asNavFor: '.gallery--accommodation-modal',
                        dots: false,
                        focusOnSelect: true,
                        arrows: false
                    });

                    // Adding custom click event to counter weird magnific behaviour on close button
                    $('.mfp-close').on('click', function(e) {
                        $.magnificPopup.close();
                    });
                }
            }
        });
    }
};

accommodationPicker.init();

$('.accordion .accordion__title').on('click', function(e) {
    e.preventDefault();

    var parent = $(this).parents('.accordion');

    if (parent.hasClass('accordion--open')) {
        parent.trigger('close');
    } else {
        parent.trigger('open');
    }
});

$('.accordion').on('open', function() {
    var current = $(this);
    current.addClass('accordion--open');
    var height = $('.accordion__body', current).outerHeight()+5;
    $('.accordion__wrap', current).css('max-height', height + "px");

    var all = current.parent().children('.accordion');
    var scrolltarget = 0;
    all.each(function(index) {
        if (index === 0) {
            scrolltarget = $(this).offset().top;
        }

        if ($(this).is(current)) {
            return false;
        } else {
            scrolltarget += $('.accordion__title', $(this)).outerHeight(true);
        }
    });

    scrolltarget += $('.anchor', current).position().top;

    window.scroll({ top: scrolltarget, left: 0, behavior: 'smooth' });

    current.trigger('opened');

    current.siblings('.accordion--open').each(function() {
        $(this).trigger('close');
    });
});

$('.accordion').on('close', function() {
    $(this).removeClass('accordion--open');
    $('.accordion__wrap', $(this)).css('max-height', 0);
    $(this).trigger('closed');
});

var resizeAccordion = function() {
    if ($('.accordion--open').length) {
        var parent = $('.accordion--open');
        parent.each(function(i) {
            var height = $('.accordion__body', $(this)).outerHeight()+5;
            $('.accordion__wrap', $(this)).css('max-height', height + "px");
        });
    }
};

$(window).on('resize', function() {
    resizeAccordion();
});

resizeAccordion();

var booking = {
    errStrings: {
        'booking_passenger_title': 'Please enter your Title',
        'booking_passenger_first_name': 'Please enter your First Name',
        'booking_passenger_last_name':  'Please enter your Last Name',
        'booking_passenger_dob':        'Please enter your Date of birth',
        'booking_passenger_email':      'Please enter your Email',
        'booking_passenger_phone':      'Please enter your Phone Number',

        'booking_passenger_address_line1':    'Please enter your Address Line1',
        'booking_passenger_address_line2':    'Please enter your Address Line2',
        'booking_passenger_address_town':     'Please enter your Address Town',
        'booking_passenger_address_county':   'Please enter your Address County',
        'booking_passenger_address_country':  'Please enter your Address Country',
        'booking_passenger_address_postcode': 'Please enter your Address Postcode',

        'booking_request_passport_check': 'Please confirm to continue',
        'booking_request_dietary_mobility_check': 'If you are unable to confirm that all passengers have no mobility or dietary requirements it will not be possible to book online. Please contact our reservations team on [number] to discuss your booking.',
        'booking_request_terms_and_conditions': 'Please accept the Terms and Conditions',

        'customer_email':                          'Please enter your Email Address',
        'order_billing_address_address_firstname': 'Please enter your First Name',
        'order_billing_address_address_lastname':  'Please enter your Last Name',
        'order_billing_address_address_country':   'Please enter your Country'
    },

    /**
     * Init / Construct.
     */
    init: function() {
        $('.booking-modal').on('click', function(e) {
            e.preventDefault();
        });

        booking.initModals();
        booking.initValidation();
        booking.initBookingForm();
    },

    addAddressLookUp: function(containerSelector, prefix, pcaKey) {
        if (typeof pca != "undefined") {
            var $container = $(containerSelector);
            var $toggle = $container.find('.address-field__lookup-toggle');
            var $county = $(prefix + '_address_county');

            var showAddressFields = function () {
                $container.removeClass('address-field--automatic');
                $container.addClass('address-field--manual');
                resizeAccordion();
            };

            $toggle.one('click', showAddressFields);

            var fields = [
                {
                    element: prefix + '_lookup',
                    field: '',
                    mode: pca.fieldMode.SEARCH,
                },
                {
                    element: prefix + '_address_line_1',
                    field: 'Line1',
                    mode: pca.fieldMode.POPULATE,
                },
                {
                    element: prefix + '_address_line_2',
                    field: 'Line2',
                    mode: pca.fieldMode.POPULATE,
                },
                {
                    element: prefix + '_address_town',
                    field: 'City',
                    mode: pca.fieldMode.POPULATE,
                },
                {
                    element: prefix + '_address_county',
                    field: 'Province',
                    mode: pca.fieldMode.POPULATE,
                },
                {
                    element: prefix + '_address_postcode',
                    field: 'PostalCode',
                    mode: pca.fieldMode.POPULATE,
                },
                {
                    element: prefix + '_address_country',
                    field: 'CountryIso2',
                    mode: pca.fieldMode.POPULATE,
                },
            ];

            var options = {
                key: pcaKey,
                suppressAutocomplete: false,
            };

            var lookup = new pca.Address(fields, options);

            lookup.listen('populate', function (address, variations) {
                if (address.CountryIso2 == 'US' || address.CountryIso2 == 'CA' || address.CountryIso2 == 'AU') {
                    $county.val('');
                }

                showAddressFields();

                $container.find('input, select').each(function() {
                    $(this).trigger('change');
                })
            });
        }
    },

    /**
     * Init the Booking Form.
     * @author David Sloan <dave@d3r.com>
     */
    initBookingForm: function() {
        $('.booking-action__button').on('click', function() {
            $('form', '.booking').trigger('submit');
            return false;
        });
    },

    /**
     * Event Handlers.
     * @author David Sloan <dave@d3r.com>
     */
    initAccommodationEvents: function() {
        // Room Count Selection
        $('.js-accomm-room-count select').on('change', function() {
            var roomCount = $(this).val(),
                $group    = $(this).closest('.accommodation-picker__row'),
                $subGroup = $('.accommodation-picker__sub-group', $group),
                $rows     = $('.accommodation-picker__row', $subGroup);

            $subGroup.toggleClass('accommodation-picker__sub-group--open', !!roomCount);

            for (var r = 0; r < roomCount; ++r) {
                $($rows[r]).addClass('accommodation-picker__row--open');
            }

            // Reset the hidden rows to defaults.
            var maxRooms = $group.data('availablerooms');
            for (var r = roomCount; r < maxRooms; ++r) {
                $($rows[r]).removeClass('accommodation-picker__row--open');
                $('.js-accomm-room-type option', $rows[r]).first().prop('selected', true).trigger('change');
                $('.js-accomm-room-occupants option', $rows[r]).first().prop('selected', true).trigger('change');
            }
        });
    },

    /**
     * Lookup a friendly error string for form validation failures.
     *
     * @param  string fieldName
     * @return string
     * @author David Sloan <dave@d3r.com>
     */
    lookupErrString: function(fieldName) {
        for (var errStr in booking.errStrings) {
            if (fieldName.indexOf(errStr) > -1) {
                if (errStr == 'booking_request_dietary_mobility_check') {
                    const number = '<span class="infinityNumber">' +
                        $("#booking_request_dietary_mobility_check_phone_number").val() +
                        '</span>';
                    return booking.errStrings[errStr].replace('[number]', number);
                }
                return booking.errStrings[errStr];
            }
        }
        return 'This field is required';
    },

    /**
     * Validate Form Field.
     *
     * @param  object $field
     * @return bool
     * @author David Sloan <dave@d3r.com>
     */
    validateField: function($field) {
        var $wrap = $field.closest('.required'),
            valid = true;

        switch ($field.attr('type')) {
            case 'checkbox':
            case 'radio':
                var elemName = $field.attr('name').replace('[', '\\[').replace(']', '\\]');
                valid = $('input[name=' + elemName + ']:checked').length;
                break;

            default:
                if ($field.attr('id').indexOf('email') > 0) {
                    var regex = /\S+@\S+\.\S+/;
                    valid = regex.test($field.val().trim());
                } else if ($field.attr('id').indexOf('phone') > 0) {
                    var regex = /^[\s()+-]*([0-9][\s()+-]*){8,30}$/;
                    valid = regex.test($field.val().trim());
                } else if ($field.attr('id').indexOf('year') > 0) {
                    var regex = /^[0-9]{2,4}$/;
                    valid = regex.test($field.val().trim());
                } else {
                    valid = ($field.val().trim().length > 0);
                }
                break;
        }

        if (!valid) {
            if ($wrap.hasClass('field-error')) {
                resizeAccordion();
                return;
            }
            $wrap.addClass('field-error');
            var errStr = booking.lookupErrString($field.attr('id'));
            if (errStr.length) {
                $wrap.append('<p class="error">' + errStr + '</p>');
            }
            resizeAccordion();
            return false;
        }

        $wrap.removeClass('field-error');
        $('p.error', $wrap).remove();
        resizeAccordion();
        return true;
    },

    scrollToFirstError: function() {
        $('html, body').animate({
            scrollTop: $('form', '.booking').find('.field-error').offset().top - 16,
        }, 2000);
    },

    /**
     * Form Validation.
     * @author David Sloan <dave@d3r.com>
     */
    initValidation: function() {
        // Let Ecom handle the validation on the payment stage.
        var paymentStage = ($('#checkout-form').length || $('.booking-form--payment').length);

        $('form', '.booking').on('submit', function(event) {
            var $form = $(this);
            var valid = true;
            $('.required .input, .required .check_box[type!=hidden]', $(this)).each(function() {
                var $field = $(this);
                if ($field.get(0).tagName == 'LABEL') {
                    $field = $('#' + $($field.get(0)).attr('for'), $field[0]);
                }

                // Let ecom handle these
                if ($field.data('sagepay')) {
                    return;
                }

                valid &= booking.validateField($field);
            });

            if (!valid) {
                booking.scrollToFirstError();
            }

            if (paymentStage && !valid) {
                event.stopImmediatePropagation();
                return false;
            }

            return !!valid;
        });

        $('.required .input', '.booking form').on('blur change', function() {
            booking.validateField($(this));
        });

        $('#booking_request_passport_check').on('click', function() {
            booking.validateField($(this));
        });
        $('#booking_request_dietary_mobility_check').on('click', function() {
            booking.validateField($(this));
        });
        $('#booking_request_terms_and_conditions').on('click', function() {
            booking.validateField($(this));
        });

        $('.required .input', '.booking form').on('keyup', function() {
            var $wrap = $(this).closest('.required');
            $wrap.removeClass('field-error');
            $('p.error', $wrap).remove();
        });
    },

    /**
     * Init Modals.
     * @author David Sloan <dave@d3r.com>
     */
    initModals: function() {
        var isMobile = $('.header__nav__mobile').is(':visible');

        var bookingUpdated = false;
        $('.booking-modal').magnificPopup({
            type: 'ajax',
            closeBtnInside: true,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span>' + (isMobile ? '&nbsp;' : 'Save') + '</span></button>',
            closeOnContentClick: false,
            ajax: {
                settings: null,
                cursor: 'mfp-ajax-cur',
                tError: '<a href="%url%">The content</a> could not be loaded.'
            },
            callbacks: {
                ajaxContentAdded: function() {
                    $('.mfp-content select').selectreplace({
                        wrapper     : 'div',
                        wrapperClass: 'select-replace',
                        value       : 'p',
                        valueClass  : 'select-replace__value',
                        svgIcon     : 'icon-select'
                    });
                    $('.mfp-close').on('click', function(e) {
                        $.magnificPopup.close();
                    });

                    $('.gallery--accommodation-modal').slick({
                        arrows: false,
                        dots: false
                    });

                    $('.gallery--accommodation-modal-nav').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        asNavFor: '.gallery--accommodation-modal',
                        dots: false,
                        focusOnSelect: true,
                        arrows: false
                    });

                    $('.mfp-content form').on('change', function() {
                        bookingUpdated = true;
                    });

                    booking.initAccommodationEvents();
                    if (accommodationPicker) {
                        accommodationPicker.initModals();

                        $('.js-accomm-room-occupants').on('change', function(event) {
                            var min = event.target.getAttribute('min');
                            var max = event.target.getAttribute('max');
                            if (event.target.value < min) {
                                event.target.value = min;
                            }
                            else if (event.target.value > max) {
                                event.target.value = max;
                            }
                        });
                    }
                },
                close: function() {
                    if (bookingUpdated) {
                        $('.mfp-content form').trigger('submit');
                        bookingUpdated = false;
                    }
                }
            }
        });
    }
};

booking.init();

(function customNav() {
    var animDuration = 150

    var $nav = $('.custom-nav')
    if($nav.length === 0) {
        return;
    }

    var $mobileToggle = $('.custom-nav__mobile-toggle')

    // Set up horizontal third tier menus
    // $('.menu__group .menu__group .menu__group .menu__group-content').each(function() {
    //     if ($(this).find('.menu__item').length <= 4) {
    //         this.classList.add('menu__group-content--horizontal')
    //     }
    // })

    function checkStickyNav() {
        if (window.scrollY > 120) {
            $nav.addClass('custom-nav--sticky')
        } else {
            $nav.removeClass('custom-nav--sticky')
        }
    }

    function removeForced() {
        $('.menu__group--forced')
            .removeClass('menu__group--forced')
            .prev()
            .removeClass('menu__link--expanded')
    }

    function closeExpanded(delay, duration) {
        delay = delay ? delay : 0
        duration = duration ? duration : 0
        $('.menu__link--expanded')
            .removeClass('menu__link--expanded')

        $('.menu__group .menu__group').not('.menu__group .menu__group .menu__group')
            .finish()
            .delay(delay)
            .slideUp(duration)
    }

    function showFirstOfThirdTier(parent) {
        var $child = $(parent)
            .find('.menu__group .menu__group-content').first()
            .find('.menu__item').first()

        // Force third tier first item expand
        $child.children('.menu__link--expandable').addClass('menu__link--expanded')
        $child.children('.menu__group').addClass('menu__group--forced')
    }

    $(window).on('scroll', function(e) {
        checkStickyNav()
    })

    $mobileToggle.on('click', function() {
        $nav.toggleClass('custom-nav--mobile-active')
    })

    // Search
    // Desktop search click reveals search input
    $('.menu__item--search .menu__link').on('click', function(e) {
        e.preventDefault()
        $('.menu__search').toggleClass('menu__search--active')
    })
    // Clicking outside of the nav menu closes search box
    $(document).on('click', 'main, footer', function(e) {
        $('.menu__search').removeClass('menu__search--active')
    })
    // Clear button
    $('.menu__search-clear-button').on('click', function() {
        $(this).prev().val('')
    })

    // Main mobile menu logic
    $('.menu').on('click', function(e) {
        var $target = $(e.target)

        if ($target.is('.menu__link') && !$target.attr('href')) {
            e.preventDefault()
        }
        if (!$('.custom-nav__mobile').is(':visible')) {
            return
        }

        var expandable    = '.menu__link--expandable',
            expandedClass = 'menu__link--expanded',
            expanded      = '.' + expandedClass

        // Explicit expand / collapse toggle separate from expanded link click logic
        if ($target.is('.expand-menu-icon')) {
            $target.parent()
                .toggleClass(expandedClass)
                .next()
                .finish()
                .slideToggle()

            e.preventDefault()
            return;
        }

        if ($target.is(expandable) && !$target.is(expanded)) {
            var $expandedSiblings = $target.closest('.menu__group').find(expanded)
            $expandedSiblings
                .removeClass(expandedClass)
                .next()
                .finish()
                .slideUp(animDuration)
            $target
                .addClass(expandedClass)
                .next()
                .finish()
                .slideDown(animDuration)

            e.preventDefault()
        }
    })

    // Main desktop menu logic
    var hoverTimeout;
    var hoverDelay = 250; // milliseconds

    $('.menu__item')
        .on('mouseenter', function(e) {
            if ($('.custom-nav__mobile').is(':visible')) {
                return
            }

            var $this = $(this);

            // Clear any existing timeout
            clearTimeout(hoverTimeout);

            // Set new timeout
            hoverTimeout = setTimeout(function() {
                removeForced()
                // If we're at the top level
                if ($this.closest('.menu__group').parent().is('.menu')) {
                    closeExpanded(0, 0)

                    showFirstOfThirdTier($this)

                    // Hide search if we hover over a top tier menu with sub a menu
                    if ($this.find('.menu__group').length) {
                        $('.menu__search').removeClass('menu__search--active')
                    }

                    $this.children('.menu__link--expandable')
                        .addClass('menu__link--expanded')
                        .next()
                        .finish()
                        .slideDown(animDuration)
                }
            }, hoverDelay);
        })
        .on('mouseleave', function(e) {
            if ($('.custom-nav__mobile').is(':visible')) {
                return
            }

            // Clear the timeout to prevent delayed enter action
            clearTimeout(hoverTimeout);

            var $this = $(this);

            // Set timeout for leave action
            hoverTimeout = setTimeout(function() {
                if ($this.closest('.menu__group').parent().is('.menu')) {
                    closeExpanded(500, animDuration)
                }

                removeForced()
            }, hoverDelay);
        })
}())

// This is originally from the underscore library
//
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

$('.filterable__dimension input[type=checkbox]').on('change', function(e, init) {
    if (init || !$(this).parents('.filterable--ajax').length) {
        return;
    }
    $('.filterable :input[value=""]').attr('disabled', true);
    $(this).parents('form').trigger('submit');
    $('.filterable :input[value=""]').attr('disabled', false);
});

$('.filterable__dimension :input').on('location_change', function(e, init) {
    if (!$(this).parents('.filterable--ajax').length) {
        return;
    }
    $('.filterable :input[value=""]').attr('disabled', true);
    $(this).parents('form').trigger('submit');
    $('.filterable :input[value=""]').attr('disabled', false);
});

$.fn.toggleFilters = function() {
    $(this).each(function() {
        $(this).on('click', function() {
            $('.filterable').toggleClass('filterable--active');
        });
    });
};

$.fn.fauxSelect = function() {
    $(this).each(function() {
        var current = $(this);
        $('.faux-select__input', current).on('click', function() {
            $('.faux-select__input--active').removeClass('faux-select__input--active');
            $(this).toggleClass('faux-select__input--active');
            var isHidden = $('.faux-select__dropdown', current).css('display') == 'none';
            $('.faux-select__dropdown').hide();
            if (isHidden) {
                $('.faux-select__dropdown', current).show();
            }
        });

        $('.faux-select__options input', current).on('change', function() {
            var result = '';
            var count = 0;
            $('.faux-select__options input', current).each(function() {
                if ($(this).prop('checked')) {
                    if (result == '') {
                        result = $(this).parent().siblings('span').html();
                    }
                    count++;
                }
            });

            if (count == 0) {
                $('.faux-select__label', current).html(current.data('all'));
                $('.faux-select__label', current).addClass('faux-select__label--placeholder');
            } else if (count > 1) {
                $('.faux-select__label', current).html(count + ' ' + current.data('itemname'));
                $('.faux-select__label', current).removeClass('faux-select__label--placeholder');
            } else {
                $('.faux-select__label', current).html(result);
                $('.faux-select__label', current).removeClass('faux-select__label--placeholder');
            }
        });
    });

    $(document).on('click', 'body', function (e) {
        if (!$(e.target).parents('.faux-select').length) {
            $('.faux-select__dropdown').hide();
            $('.faux-select__input').removeClass('faux-select__input--active');
        }
    });
}

$('.faux-select').fauxSelect();

$('.js-toggle-filters').toggleFilters();

var filters_xhr;
function loadAjax(url) {
    var form = $('form.filterable');

    if (filters_xhr !== undefined && filters_xhr.readyState <= 4) {
        filters_xhr.abort();
    }

    $('.filterable__results').addClass('filterable__results--loading');

    $('.filterable__dimension__label--checkbox :input').attr('disabled', true);
    $('.filterable__dimension__label--checkbox').addClass('filterable__dimension__label--disabled');

    filters_xhr = $.ajax(url, {
        success: function(result) {
            var labels = $('.filterable__dimension__label--checkbox').children('span');
            labels.each(function() {
                $(this).html($(this).html().replace(/\(([0-9])+\)/g, '(0)'));
            });

            $('.filterable__feedback--noresults').addClass('d3r-hidden');
            $('.filterable__results').removeClass('filterable__results--loading');
            if (result.payload.count == 0) {
                $('.filterable__feedback--noresults').removeClass('d3r-hidden');
            }
            $('.filterable__results__items').html(result.payload.items + result.payload.pagination);
            $('#filterable-location-search').val(result.payload.search);
            $.each(result.payload.filters, function(filterName, options) {
                if (filterName != 'locations') {
                    var prev;
                    $.each(options, function(value, option) {
                        var val = $('.filterable__dimension :input[name^="'+filterName+'"][value="'+value+'"]');

                        var option_label = option.label + ' (' +  option.count + ')';
                        val.parents('.filterable__dimension__label--checkbox').children('span').html(option_label);

                        if (val.length) {
                            if (option.count || option.selected) {
                                val.attr('disabled', false);
                                val.parents('.filterable__dimension__label--checkbox').removeClass('filterable__dimension__label--disabled');
                            }
                            val.prop('checked', option.selected);
                            val.trigger('change', [true]);
                            prev = val.parents('.filterable__dimension__label--checkbox');
                        } else if (prev) {
                            var item = '<label class="filterable__dimension__label--checkbox"><input type="checkbox" name="'
                                + filterName + '[]" value="' + value + '"' + (option.$selected ? ' checked="checked"' : null)
                                + ' /> <span>' + option.label + ' (' +  option.count + ')</span></label>';
                            prev.after(item);
                            var val = $('.filterable__dimension :input[name^="'+filterName+'"][value="'+value+'"]').checkReplace();
                        } else {
                            var item = '<label class="filterable__dimension__label--checkbox"><input type="checkbox" name="'
                                + filterName + '[]" value="' + value + '"' + (option.$selected ? ' checked="checked"' : null)
                                + ' /> <span>' + option.label + ' (' +  option.count + ')</span></label>';
                            $('.filterable__dimension--'+filterName+' .faux-select__options').prepend(item);
                            var val = $('.filterable__dimension :input[name^="'+filterName+'"][value="'+value+'"]').checkReplace();
                        }
                    });
                    $('.filterable__dimension :input[name^="'+filterName+'"]:checked:disabled').each(function() {
                        $(this).prop('checked', false);
                        $(this).trigger('change', [true]);
                    });
                } else {
                    $('.filterable__dimension--locations').attr('disabled', false);
                    $('#filterable-location-locations').val(options.search);
                    $('#filterable-location-locations-geo').val(options.geo);
                    $('#filterable-location-locations-search').val(options.search);
                }
            });

            var selections = '';
            $.each(result.payload.selections, function(key, option) {
                selections += '<span class="filterable__selection"><a class="filterable__remove" href="'+option['url']+'">×</a> '+option['label']+'</span>';
            });

            $('.filterable__selections').html(selections);
            $('.filterable__overview').toggleClass('filterable__overview--active', result.payload.selections.length > 0);

            if (selections == '') {
                $('.clear-filters').hide();
            } else {
                $('.clear-filters').css('display', 'inline-block');
            }

            $('.js-listing-count-start').text(result.payload.countStart);
            $('.js-listing-count-end').text(result.payload.countEnd);
            $('.js-listing-count-total').text(result.payload.countTotal);
        },
        error: function() {
            console.log('An error occured');
        }
    });
}

$(document).on('click', '.filterable--ajax .filterable__overview a', function(e) {
    e.preventDefault();
    var url = $(this).attr('href');

    $(this).parent().remove();

    if (!$('.filterable__selections a').length) {
        $('.clear-filters').hide();
    }

    window.history.pushState({
        type: 'filters',
        url: url
    }, null, url);

    loadAjax(url);
});

$(document).on('change', '.filterable--ajax .filterable__option--sort select', function(e) {
    e.preventDefault();

    $(this).parents('form').trigger('submit');
});

$('form.filterable--ajax').on('submit', function(e) {
    e.preventDefault();
    var url = "?" + $(this).serialize();

    window.history.pushState({
        type: 'filters',
        url: url
    }, null, url);

    url += '&ts=' + (new Date()).getTime();
    loadAjax(url);
});

window.addEventListener('popstate', function(e) {
    if (e.state && e.state.url) {
        loadAjax(e.state.url);
    }
});

/**
 *
 */
;(function ( $, window, document, undefined ) {

    // Create the defaults once
    var defaults = {},
        initialized = false,
        instances = [];

    function recalculate(e) {
        var scroll = $(window).scrollTop();

        for (var i = 0; i < instances.length; i++) {
            var bounding = instances[i].element[0].getBoundingClientRect();
            instances[i].dummy.height(bounding.height);
            instances[i].top = parseInt(instances[i].element.css('top'));

            if (instances[i].active) {
                var boundingDummy = instances[i].dummy[0].getBoundingClientRect();
                instances[i].offset = scroll + boundingDummy.top;
            } else {
                instances[i].offset = scroll + bounding.top;
            }
        }
    }

    function update(e) {
        var scroll = $(window).scrollTop();

        for (var i = 0; i < instances.length; i++) {
            var instance = instances[i];

            var isMinWidth = !instance.minWidth || window.matchMedia('(min-width: ' + instance.minWidth + ')').matches;
            if (!isMinWidth) {
                instance.element.removeClass('fixedsticky');
                instance.element.removeClass('fixedsticky-on');
                continue;
            }

            if (!instance.element.hasClass('fixedsticky')) {
                instance.element.addClass('fixedsticky');
            }

            if (!instance.active && instance.offset - instance.top <= scroll) {
                instance.element.addClass('fixedsticky-on');
                instance.active = true;
            }

            if (instance.active && instance.offset - instance.top > scroll) {
                instance.element.removeClass('fixedsticky-on');
                instance.active = false;
            }
        }
    }

    function reset() {
        recalculate();
        update();
    }

    // The actual plugin constructor
    function FixedSticky(element, options) {
        this.element = $(element);
        this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this.offset = 0;
        this.active = false;
        this.minWidth = this.element.attr('data-fixedsticky-min-width');
        instances.push(this);
        this.init();
    }

    FixedSticky.prototype = {

        bind: function() {
            if (initialized) {
                return;
            }

            $(window).on('resize', debounce(reset, 250));
            $(window).on('scroll', update);

            initialized = true;
        },

        init: function() {
            this.bind();
            this.dummy = $('<div class="fixedsticky-dummy"></div>').insertAfter(this.element);
            recalculate();
            update();
        },
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn.fixedsticky = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_fixedsticky")) {
                $.data(this, "plugin_fixedsticky",
                new FixedSticky( this, options ));
            }
        });
    };

})( jQuery, window, document );

(function() {
    var $search = $('.bookingcom-availability');
    if (!$search.length) {
        return;
    }

    //checkin and checkout selectors
    var $checkin = $('.js-checkin-datepicker');
    var $checkout = $('.js-checkout-datepicker');

    var options = {
        format: 'ddd d mmmm, yyyy',
        formatSubmit: 'yyyy-mm-dd',
        hiddenName: true,
        firstDay: 1,
        clear: false,
        today: '<span>Today</span>',
        close: '<span>Close</span>',
        min: new Date(),
        onClose: function () {
            var isCheckinSelector = this.$root.is('.js-checkin-date-calendar > div');
            var checkinDate = (isCheckinSelector ? this : $checkin.pickadate('picker')).get('select').obj;
            var checkoutDate = (isCheckinSelector ? $checkout.pickadate('picker') : this).get('select').obj;
            var minCheckoutDate = checkinDate.addDays(parseInt($checkin.attr("data-minimum-stay")));
            
            //check if the current checkout date is before the min checkout date
            if (checkoutDate.getTime() < minCheckoutDate.getTime()) {
                checkoutDate = minCheckoutDate;
            }

            //go through all selectors and update them
            $checkin.each(function(){
                $(this).pickadate('picker').set('select', checkinDate);
            });
            $checkout.each(function(){
                $(this).pickadate('picker').set('select', checkoutDate).set('min', minCheckoutDate);
            });
        }
    };

    //assign the options to the datepicker dropdowns
    var  cl,i = 0;
    $(".js-checkin-datepicker,.js-checkout-datepicker").each(function(){
        i++;
        cl = 'in';
        options = Object.assign({}, options);
        if ($(this).is(".js-checkout-datepicker")) {
            options.min = options.min.addDays(parseInt($checkin.attr("data-minimum-stay")));
            cl = 'out';
        }
        options['container'] = '[data-booking-com-dropdown-index=' + i + '] + .js-check' + cl + '-date-calendar';
        $(this).parent().attr('data-booking-com-dropdown-index', i)
        $(this).pickadate(options);
        $(this).siblings('label').attr('for', $(this).attr('id'));
    });

    //adults / children / rooms selector
    var $numAdults = $('.number_of_adults');
    var $numChildren = $('.number_of_children');
    var $numRooms = $('.number_of_rooms');

    var occupancyFieldsSelector = '.bookingcom-availability__occupancy-fields';
    var $occupancyFields = $(occupancyFieldsSelector);

    var $fauxOccupancy = $('.js-occupancy-faux-select');
    var $occupancyFormat = $fauxOccupancy.attr('data-format');

    var updateOccupancy = function() {
        var text = $occupancyFormat;
        text = text.replace('{num_adults}', $numAdults.val());
        text = text.replace('{num_children}', $numChildren.val());
        text = text.replace('{num_rooms}', $numRooms.val());

        $fauxOccupancy.text(text);
    };

    var ageFieldTemplate = $('#bookingcom-availability-age-template').html();

    var clearAgeFields = function() {
        $('.js-bookingcom-availability-age').remove();
    };

    var removeAgeField = function() {
        $('.js-bookingcom-availability-age:last-child').each(function(){
            $(this).remove();
        });
    };

    var addAgeField = function(index) {
        var $newAgeField = ageFieldTemplate;
        $newAgeField = $newAgeField.replace(/{child_index}/g, index);
        $occupancyFields.append($newAgeField);
        $('.js-bookingcom-availability-age:last-child select').each(function(){
            $(this).on('change', function(){
                var currentSelect = this;
                $('select[data-child-index=' + $(this).attr('data-child-index') + ']').each(function(){
                    if (this != currentSelect) {
                        $(this).val(currentSelect.value)
                            .siblings('.select-replace__value').text(currentSelect.value);
                    }
                });
            });
        });
        window.TS.initSelectReplace($occupancyFields, {wrapperClass: 'select-replace l-six-tenths'});
    };

    var toggleDecrementButton = function(targetQty, toggleTo){
        $("label[for=" + targetQty.replace(".", "") + "] + .bookingcom-availability__decrement").each(function(){
            $(this).attr('disabled', toggleTo);
        });
    }

    $('.bookingcom-availability__decrement, .bookingcom-availability__increment').on('click', function() {
        var $this = $(this);
        var targetQty = $this.attr('data-qty-target');
        var $targetQty = $(targetQty);
        
        var val = parseInt($targetQty.val());
        if ($this.hasClass('bookingcom-availability__decrement')) {
            val--;
            if (val === 0) {
                toggleDecrementButton(targetQty, true);
            }

            if (targetQty === '.number_of_children') {
                removeAgeField();
            }
        } else {
            if (val === 0) {
                toggleDecrementButton(targetQty, false);
            }
            val++;

            if (targetQty === '.number_of_children') {
                addAgeField(val);
            }
        }

        $targetQty.each(function(){
            $(this).val(val);
        });
        $("label[for="+targetQty.replace(".","")+"] + button + .bookingcom__faux-qty").each(function(){
            $(this).text(val);
        });
        updateOccupancy();
    });

    //click label next to adults/children/room dropdown to make the dropdown show
    $('.faux-select').each(function(){
        var select = this;
        $(this).siblings('.field').children('label').on('click', function(){
            setTimeout(function(){
                $(select).find('.faux-select__input').addClass('faux-select__input--active');
                $(select).find('.faux-select__dropdown').show();
            }, 1);
        });
    });
}())

TRIPSMITHS.quantityControls = [];

TRIPSMITHS.quantityControl = function() {
    var quantityControlInput = document.querySelectorAll('[quantity-control]');

    for (var i = 0; i < quantityControlInput.length; i++) {
        (function(i) {
            var quantityControl = new TRIPSMITHS.QuantityControl({
                el: quantityControlInput[i],
                mode: quantityControlInput[i].getAttribute('quantity-control'),
                id: 'quantity-control-' + i
            });
            quantityControl.init();

            TRIPSMITHS.quantityControls.push(quantityControl);
        })(i);
    }
};


var $window = $(window);

$.fn.isInViewport = function() {
    var $this = $(this);
    var elementTop = $this.offset().top;
    var elementBottom = elementTop + $this.outerHeight();
    var viewportTop = $window.scrollTop();
    var viewportBottom = viewportTop + $window.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(function() {
    var initSelectReplace = function($container, overrideOptions) {
        overrideOptions = overrideOptions || {};

        var defaultOptions = {
            wrapper: 'div',
            wrapperClass: 'select-replace',
            value : 'p',
            valueClass : 'select-replace__value',
            svgIcon : 'icon-select',
        };
        var options = Object.assign(defaultOptions, overrideOptions);

        var $select = $container.find('select'); // Get all selects within container
        $select = $select.not($container.find('.select-replace select')); // Remove ones that are already 'select-replace'd

        $select.selectreplace(options);
    }

    var initCheckReplace = function($base) {
        $base.find('input[type=checkbox]').not('.no-replace').checkReplace();
    };

    var stripTrailingSlash = function(url) {
        // Remove trailing slash if found
        if (url[url.length - 1] === '/') {
            url = url.substring(0, url.length - 1);
        }

        return url;
    };

    $('.fixedsticky').fixedsticky();

    var $body = $('body');
    initSelectReplace($body);
    initCheckReplace($body);

    $('.page-nav__mobile').on('click', function() {
        $(this).parents('.page-nav').toggleClass('page-nav--open');
    });

    $('.page-nav__link').on('click', function() {
        $(this).parents('.page-nav').removeClass('page-nav--open');
    });

    $('.header__nav__mobile').on('click', function() {
        $(this).parents('.header__nav').toggleClass('header__nav--open');
    });

    $('.header__nav__link').on('click', function() {
        $(this).parents('.header__nav').removeClass('header__nav--open');
    });

    $(document).on('click', 'a[href^="#"]:not(a[href="#"])', function(e) {
        e.preventDefault();
        window.scroll({ top: $($(this).attr('href')).offset().top, left: 0, behavior: 'smooth' });
    });

    $(document).on('click', '.highlight .highlight__link[href^="#activity"]', function(e) {
        e.preventDefault();

        var activity = $($(this).attr('href'));
        activity.parents('.accordion').trigger('open');
    });

    $(document).on('click', '[data-gacategory]', function() {
        TRIPSMITHS.Tracking.trackEvent(
            $(this).attr('data-gacategory'),
            $(this).attr('data-gaaction'),
            $(this).attr('data-galabel')
        );
    });

    if ($('.callback-cta').length > 0) {
        $('.callback-cta__link').magnificPopup({
            type: 'ajax',
            closeBtnInside: false,
            ajax: {
                settings: {
                    url: location.pathname + '/callback-modal?tour=' + $('.callback-cta').data().tourId
                },
                cursor: 'mfp-ajax-cur',
                tError: '<a href="%url%">The content</a> could not be loaded.'
            },
            callbacks: {
                ajaxContentAdded: function() {
                    $.magnificPopup.instance.contentContainer.addClass('callback-modal-container')
                    $('.mfp-close').on('click', function(e) {
                        $.magnificPopup.close();
                    });

                    initSelectReplace($('.callback-modal'));

                    var form = $('.callback-modal__body-form');
                        form.on('submit', function (evt) {
                            evt.preventDefault();

                            $.post(form.attr('action'), form.serialize())
                                .success(function(data){
                                    $.magnificPopup.instance.contentContainer.html(data);
                                });
                        });
                },
                close: function() {
                }
            }
        });
    }

    var $brochureModalLinks = $('.js-brochure-modal');
    if ($brochureModalLinks.length > 0) {
        $brochureModalLinks.each(function() {
            var $brochureModalLink = $(this);

            var url = $brochureModalLink.attr('data-url');
            if (!url) {
                url = location.pathname;
            }
            $brochureModalLink.magnificPopup({
                type: 'ajax',
                closeBtnInside: false,
                ajax: {
                    settings: {
                        url: stripTrailingSlash(url) + '/brochure-modal',
                    },
                    cursor: 'mfp-ajax-cur',
                    tError: '<a href="%url%">The content</a> could not be loaded.',
                },
                callbacks: {
                    ajaxContentAdded: function() {
                        $.magnificPopup.instance.contentContainer.addClass('brochure-modal-container');
                        $('.mfp-close').on('click', function() {
                            $.magnificPopup.close();
                        });

                        var $modal = $('.brochure-modal');

                        initSelectReplace($modal);
                        initCheckReplace($modal);

                        var form = $('.brochure-modal__form');
                        form.on('submit', function(event) {
                            event.preventDefault();

                            $.post(form.attr('action'), form.serialize())
                                .done(function(data) {
                                    // If successful url to download brochure will be returned
                                    if (data && data.payload && data.payload.redirect) {
                                        /**
                                         * Even though a redirect to a different url,
                                         * it's a download link so will still be on this page so close popup
                                         */
                                        $.magnificPopup.close();
                                        window.location.href = data.payload.redirect;
                                    } else {
                                        // Else submission failed so render latest html
                                        $.magnificPopup.instance.contentContainer.html(data);
                                    }
                                });
                        });
                    },
                },
            });
        });
    }

    window.TS = window.TS = {};
    window.TS.initSelectReplace = initSelectReplace;

    // This is a snippet for detecting if the Accommodation picker is
    // visible in the current viewport.
    //
    // The idea here is that if we are in mobile mode where the booking
    // bar is stickied to the bottom of the viewport, we can hide that
    // when we are in the accommodation picker so that users don't get
    // confused by the two possible booking/availability buttons.
    var $availabilitySection = $('.js-availability-section');
    var $bookingBar = $('.booking-bar__mobile');
    if ($availabilitySection.length) {
        $(window).on('resize scroll', function() {
            // The contact bar will always be visible on mobile, so our
            // checks are against that.
            if ($('.booking-bar__mobile-contact').is(':visible')) {
                if ($availabilitySection.isInViewport() &&
                    !$bookingBar.hasClass('booking-bar__mobile--hidden')
                ) {
                    $bookingBar.addClass('booking-bar__mobile--hidden');
                } else if (!$availabilitySection.isInViewport() &&
                    $bookingBar.hasClass('booking-bar__mobile--hidden')
                ) {
                    $bookingBar.removeClass('booking-bar__mobile--hidden');
                }
            }
        });
    }
});

;(function($) {
    var $footerSubscribe = $('.footer-subscribe-bar');

    if ($footerSubscribe.length) {
        var cookieName = 'd3r_footer_subscribe_closed';
        var cookie = document.cookie.match(cookieName);

        // If not closed show
        if (cookie == null) {
            $footerSubscribe.show();

            var submitted = false;

            var $outer = $('.outer-wrapper');
            var $cta = $('.enquiry-cta--floating');
            var $bookingBar = $('.booking-bar__mobile');
            var $footerSubscribeBarHeading = $('.footer-subscribe-bar__heading');
            var $footerSubscribeBarTitle = $('.footer-subscribe-bar__title');

            var setCookie = function(expiry) {
                // Set the maximum expiry date possibly
                var now = new Date();

                if (submitted || !expiry) {
                    expiry = new Date('01/18/2038');
                }

                document.cookie = cookieName + '=' + now.getTime() + '; expires=' + expiry.toGMTString() + '; path=/';
            }

            var resetOffset = function() {
                var height = $footerSubscribeBarHeading.outerHeight(true);

                // Reset
                $outer.css('padding-bottom', '');
                $bookingBar.css('bottom', '');
                $cta.css('bottom', '');

                $outer.css('padding-bottom', parseInt($outer.css('padding-bottom')) + height);
                $bookingBar.css('bottom', parseInt($bookingBar.css('bottom')) + height);
                $cta.css('bottom', parseInt($cta.css('bottom')) + height);
            }

            $(resetOffset);
            $(window).on('resize', resetOffset);

            $footerSubscribeBarTitle.on('click', function() {
                $footerSubscribe.toggleClass('footer-subscribe-bar--open');
            });

            $('.footer-subscribe-bar__close').on('click', function() {
                $footerSubscribe.remove();
                resetOffset();
                var now = new Date();
                now.setDate(now.getDate() + 1);
                setCookie(now);
            });

            $(document).on('submit', '.footer-subscribe-bar__form', function(e) {
                e.preventDefault();

                var $form = $(this);
                var $content = $form.parents('.footer-subscribe-bar__content');

                var data = $form.serializeArray();
                data.push({
                    name: 'footer',
                    value: true,
                });

                $.ajax({
                    url: $form.attr('action'),
                    type: 'POST',
                    data: data,
                    success: function(data) {
                        $content.replaceWith($(data).find('.footer-subscribe-bar__content'));

                        if ($('.footer-subscribe-bar__thanks').length) {
                            submitted = true;
                            setCookie();
                        }
                    },
                });
            });
        }
    }
})($);

$('.js-brochures-sign-up').on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);

    $form.find('.field').removeClass('error');

    var data = {
        sign_up_email: $form.find("[id$='_sign_up_email']").val(),
        sign_up_optin: $form.find("[id$='_sign_up_optin']:checked").length ? 'true' : 'false',
    };

    if (!data.sign_up_email) {
        window.location = $form.attr('data-download-url');
        return;
    }

    $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: data,
        success: function(data) {
            if (data.result){
                window.location = $form.attr('data-download-url');
                $form.hide();
                $form.siblings('.js-brochures-thanks').show();
                return;
            }

            var errors = data.payload.errors;

            for (var key in errors){
                if (errors.hasOwnProperty(key)) {
                    var $input = $form.find("[id$='_" + key + "']")

                    var $field = $input.parents('.field');
                    $field.addClass('error');

                    var $error = $field.find('.error');
                    if ($error.length) {
                        $error.text(errors[key]);
                    } else {
                        $field.append('<p class="error">' + errors[key] + '</p>');
                    }
                }
            }
        },
    });
});

TRIPSMITHS.quantityControl();
